// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zInstant = z.string();

export const zAdminBanUserResponse = z.object({
    success: z.boolean()
});

export const zBackofficeAdminDisabled = z.object({
    code: z.enum(['account_disabled']),
    message: z.string()
});

export const zBackofficeCsrfInvalid = z.object({
    code: z.enum(['backoffice_csrf_invalid']),
    message: z.string()
});

export const zAdminForbidden = z.object({
    code: z.enum(['admin_forbidden']),
    message: z.string()
});

export const zAdminUnbanUserResponse = z.object({
    success: z.boolean()
});

export const zAdminDeleteUserResponse = z.object({
    success: z.boolean()
});

export const zInstantRange = z.object({
    from: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    to: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

export const zImagePayload = z.object({
    url: z.string(),
    blurhash: z.union([
        z.string(),
        z.null()
    ]),
    width: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    height: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    variants: z.union([
        z.object({
            original: z.optional(z.string()),
            thumbnail: z.optional(z.string()),
            small: z.optional(z.string()),
            medium: z.optional(z.string()),
            large: z.optional(z.string())
        }),
        z.null()
    ])
});

export const zImageVariants = z.object({
    original: z.optional(z.string()),
    thumbnail: z.optional(z.string()),
    small: z.optional(z.string()),
    medium: z.optional(z.string()),
    large: z.optional(z.string())
});

export const zInstantOutput = z.string();

export const zAdminUserListItem = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    status: z.enum([
        'active',
        'banned',
        'deleted'
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])),
    emailVerified: z.boolean(),
    emailVerifiedAt: z.union([
        z.string(),
        z.null()
    ]),
    banned: z.boolean(),
    banReason: z.union([
        z.string(),
        z.null()
    ]),
    banExpires: z.union([
        z.string(),
        z.null()
    ]),
    signupSource: z.enum(['email']),
    createdAt: zInstantOutput
});

export const zOffsetPaginationMeta = z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number()
});

export const zAdminHome = z.object({
    anomalies: z.union([
        z.object({
            total: z.int().gte(-9007199254740991).lte(9007199254740991),
            byKind: z.object({
                transmission_not_delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
                email_bounced: z.int().gte(-9007199254740991).lte(9007199254740991),
                ranking_failed: z.int().gte(-9007199254740991).lte(9007199254740991),
                offer_not_sent: z.int().gte(-9007199254740991).lte(9007199254740991),
                offer_bounced: z.int().gte(-9007199254740991).lte(9007199254740991)
            }),
            oldest: z.array(z.object({
                id: z.string(),
                kind: z.enum([
                    'transmission_not_delivered',
                    'email_bounced',
                    'ranking_failed',
                    'offer_not_sent',
                    'offer_bounced'
                ]),
                residence: z.union([
                    z.object({
                        id: z.string(),
                        name: z.string()
                    }),
                    z.null()
                ]),
                protocol: z.union([
                    z.string(),
                    z.null()
                ]),
                openedAt: zInstantOutput
            }))
        }),
        z.null()
    ]),
    dsuQuota: z.union([
        z.object({
            belowThreshold: z.array(z.object({
                residence: z.object({
                    id: z.string(),
                    name: z.string()
                }),
                threshold: z.int().gte(-9007199254740991).lte(9007199254740991),
                dsuSeats: z.int().gte(-9007199254740991).lte(9007199254740991),
                gap: z.int().gte(-9007199254740991).lte(9007199254740991)
            }))
        }),
        z.null()
    ]),
    calls: z.union([
        z.array(z.object({
            residence: z.object({
                id: z.string(),
                name: z.string()
            }),
            state: z.enum([
                'draft',
                'published',
                'open',
                'closed'
            ]),
            startAt: z.union([
                z.string(),
                z.null()
            ]),
            closeAt: z.union([
                z.string(),
                z.null()
            ]),
            validApplications: z.int().gte(-9007199254740991).lte(9007199254740991),
            openFlags: z.int().gte(-9007199254740991).lte(9007199254740991),
            intake: z.object({
                state: z.enum([
                    'not_started',
                    'open',
                    'closed'
                ]),
                closesAt: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            ranking: z.union([
                z.object({
                    state: z.enum([
                        'control',
                        'published_review',
                        'final'
                    ]),
                    pageState: z.enum([
                        'placeholder',
                        'enabled',
                        'disabled'
                    ]),
                    versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
                    computedAt: zInstantOutput,
                    fingerprint: z.string()
                }),
                z.null()
            ]),
            offers: z.union([
                z.object({
                    launchedAt: zInstantOutput,
                    waiting: z.int().gte(-9007199254740991).lte(9007199254740991),
                    accepted: z.int().gte(-9007199254740991).lte(9007199254740991),
                    overdue: z.int().gte(-9007199254740991).lte(9007199254740991)
                }),
                z.null()
            ])
        })),
        z.null()
    ]),
    requests: z.union([
        z.object({
            total: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ])
});

export const zRankingStatus = z.object({
    state: z.enum([
        'control',
        'published_review',
        'final'
    ]),
    pageState: z.enum([
        'placeholder',
        'enabled',
        'disabled'
    ]),
    versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
    computedAt: zInstantOutput,
    fingerprint: z.string()
});

export const zAdminUserSessionsFilter = z.object({
    userId: z.string(),
    status: z.optional(z.union([
        z.array(z.enum([
            'active',
            'revoked',
            'expired'
        ])).min(1).max(3),
        z.null()
    ]))
});

export const zSessionDeviceBrowser = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceOs = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceInfo = z.object({
    type: z.union([
        z.string(),
        z.null()
    ]),
    model: z.union([
        z.string(),
        z.null()
    ]),
    vendor: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceEngine = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zAdminUserSessionItem = z.object({
    id: z.string(),
    ipAddress: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    device: z.union([
        z.object({
            browser: zSessionDeviceBrowser,
            os: zSessionDeviceOs,
            device: zSessionDeviceInfo,
            engine: zSessionDeviceEngine
        }),
        z.null()
    ]),
    creationSource: z.enum(['email_otp']),
    rememberMe: z.boolean(),
    status: z.enum([
        'active',
        'revoked',
        'expired'
    ]),
    createdAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    expiresAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDevice = z.object({
    browser: zSessionDeviceBrowser,
    os: zSessionDeviceOs,
    device: zSessionDeviceInfo,
    engine: zSessionDeviceEngine
});

export const zAcademicYear = z.string().regex(/^\d{4}\/\d{4}$/);

export const zApplicationDraft = z.object({
    id: z.string(),
    academicYear: zAcademicYear,
    state: z.enum(['draft', 'submitted']),
    roomPreference: z.enum([
        'single',
        'double',
        'none'
    ]),
    excludeQ70: z.boolean(),
    needsEquipped: z.boolean(),
    privacyNoticeAcceptedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zStudentProfile = z.object({
    lastName: z.union([
        z.string().min(1).max(100),
        z.null()
    ]),
    firstName: z.union([
        z.string().min(1).max(100),
        z.null()
    ]),
    birthDate: z.union([
        z.string(),
        z.null()
    ]),
    birthMunicipalityIstatCode: z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ]),
    birthCountryCode: z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ]),
    taxCode: z.union([
        z.string().regex(/^[A-Za-z0-9]{16}$/),
        z.null()
    ]),
    passportNumber: z.union([
        z.string().min(5).max(30),
        z.null()
    ]),
    phone: z.union([
        z.string().regex(/^\+[1-9]\d{6,14}$/),
        z.null()
    ]),
    familyAbroad: z.boolean(),
    residenceAddress: z.union([
        z.string().min(1).max(200),
        z.null()
    ]),
    residencePostalCode: z.union([
        z.string().regex(/^\d{5}$/),
        z.null()
    ]),
    residenceMunicipalityIstatCode: z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ]),
    residenceCountryCode: z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ]),
    institutionCode: z.union([
        z.string().min(1).max(10),
        z.null()
    ]),
    campusCode: z.union([
        z.string().min(1).max(20),
        z.null()
    ]),
    courseName: z.union([
        z.string().min(1).max(200),
        z.null()
    ]),
    campusAddress: z.union([
        z.string().min(1).max(200),
        z.null()
    ]),
    courseType: z.nullable(z.enum([
        'bachelor',
        'master',
        'single_cycle',
        'phd',
        'specialization'
    ])),
    enrollmentYear: z.union([
        z.int().gte(1).lte(6),
        z.null()
    ]),
    studentNumber: z.union([
        z.string().min(1).max(30),
        z.null()
    ]),
    preEnrollmentNumber: z.union([
        z.string().min(1).max(30),
        z.null()
    ]),
    credits: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    extraSemester: z.boolean(),
    gradeAverage: z.union([
        z.number().gte(18).lte(30),
        z.null()
    ]),
    iseeDeclared: z.union([
        z.boolean(),
        z.null()
    ]),
    iseeuCents: z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ]),
    ispeuCents: z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ])
});

export const zFloatingDateOutput = z.string();

export const zMunicipality = z.object({
    istatCode: z.string(),
    name: z.string(),
    provinceCode: z.string(),
    provinceName: z.string(),
    regionName: z.string()
});

export const zStudentProfileSection = z.object({
    status: z.enum(['complete', 'incomplete']),
    missing: z.array(z.string())
});

export const zStudentProfileView = z.object({
    email: z.string(),
    profile: zStudentProfile,
    places: z.object({
        birthMunicipality: z.union([
            z.object({
                istatCode: z.string(),
                name: z.string(),
                provinceCode: z.string(),
                provinceName: z.string(),
                regionName: z.string()
            }),
            z.null()
        ]),
        residenceMunicipality: z.union([
            z.object({
                istatCode: z.string(),
                name: z.string(),
                provinceCode: z.string(),
                provinceName: z.string(),
                regionName: z.string()
            }),
            z.null()
        ])
    }),
    hasSignedApplications: z.boolean(),
    annualData: z.object({
        academicYear: zAcademicYear,
        toReview: z.boolean()
    }),
    creditCourses: z.array(z.object({
        courseType: z.enum([
            'bachelor',
            'master',
            'single_cycle',
            'phd',
            'specialization'
        ]),
        years: z.array(z.int().gte(-9007199254740991).lte(9007199254740991)),
        extraSemesterYears: z.array(z.int().gte(-9007199254740991).lte(9007199254740991)),
        gradeYears: z.array(z.int().gte(-9007199254740991).lte(9007199254740991))
    })),
    sections: z.object({
        personal: zStudentProfileSection,
        contacts: zStudentProfileSection,
        residence: zStudentProfileSection,
        university: zStudentProfileSection,
        economic: zStudentProfileSection
    })
});

export const zApplicationChoice = z.object({
    residenceId: z.string(),
    residenceName: z.string(),
    residenceSlug: z.string(),
    callId: z.string(),
    academicYear: zAcademicYear,
    operatorLegalName: z.string(),
    addedAt: zInstantOutput,
    replacesProtocol: z.union([
        z.string(),
        z.null()
    ]),
    annex: z.object({
        state: z.enum([
            'to_download',
            'to_upload',
            'uploaded',
            'stale'
        ]),
        fileName: z.union([
            z.string(),
            z.null()
        ]),
        sizeInBytes: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        uploadedAt: z.union([
            z.string(),
            z.null()
        ]),
        totalBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zApplicationSectionState = z.object({
    complete: z.boolean(),
    missing: z.array(z.string())
});

export const zApplicationDeclaration = z.object({
    code: z.enum([
        'off_site',
        'no_debts',
        'no_convictions',
        'no_incompatible_illness'
    ]),
    text: z.string(),
    madeAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zApplicationDocument = z.object({
    kind: z.enum([
        'identity',
        'enrollment',
        'iseeu_ispeu',
        'credits_screenshot',
        'doctoral_enrollment',
        'disability'
    ]),
    required: z.boolean(),
    uploaded: z.union([
        z.object({
            id: z.string(),
            fileName: z.string(),
            mimeType: z.string(),
            sizeInBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
            uploadedAt: zInstantOutput
        }),
        z.null()
    ])
});

export const zApplicationWarning = z.object({
    id: z.string(),
    code: z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ]),
    rulesVersionId: z.int().gte(-9007199254740991).lte(9007199254740991),
    residenceId: z.union([
        z.string(),
        z.null()
    ]),
    confirmed: z.boolean()
});

export const zEligibilityQuota = z.object({
    eligible: z.boolean(),
    reason: z.enum([
        'ok',
        'iseeu_above',
        'ispeu_above',
        'offsite_not_met',
        'cfu_below_min',
        'missing_data',
        'excluded_by_student'
    ])
});

export const zEligibility = z.object({
    category: z.nullable(z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ])),
    quotas: z.object({
        q30: zEligibilityQuota,
        q70: zEligibilityQuota
    }),
    standing: z.enum([
        'quota_30',
        'quota_70_only',
        'no_quota',
        'undetermined'
    ]),
    offSite: z.union([
        z.object({
            status: z.enum([
                'off_site',
                'commuter',
                'in_site'
            ]),
            reason: z.enum([
                'family_abroad',
                'listed_off_site',
                'outside_region',
                'outside_province',
                'listed_commuter',
                'distance',
                'same_area'
            ]),
            provisional: z.boolean(),
            distanceKm: z.union([
                z.number(),
                z.null()
            ])
        }),
        z.null()
    ]),
    creditsRequired: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    warnings: z.array(z.object({
        code: z.enum([
            'iseeu_above',
            'ispeu_above',
            'cfu_below_min',
            'offsite_not_met'
        ]),
        value: z.union([
            z.number(),
            z.string()
        ])
    }))
});

export const zEligibilityForVersion = z.object({
    rulesVersionId: z.int().gte(-9007199254740991).lte(9007199254740991),
    residenceIds: z.array(z.string()),
    result: zEligibility
});

export const zEligibilityOffSite = z.object({
    status: z.enum([
        'off_site',
        'commuter',
        'in_site'
    ]),
    reason: z.enum([
        'family_abroad',
        'listed_off_site',
        'outside_region',
        'outside_province',
        'listed_commuter',
        'distance',
        'same_area'
    ]),
    provisional: z.boolean(),
    distanceKm: z.union([
        z.number(),
        z.null()
    ])
});

export const zApplicationUnreadNotice = z.object({
    id: z.string(),
    code: z.enum([
        'residence_closed',
        'institution_not_admitted',
        'link_institution_not_admitted',
        'link_residence_not_equipped',
        'link_call_not_open'
    ]),
    residenceName: z.string(),
    createdAt: zInstantOutput
});

export const zApplicationDraftView = z.object({
    application: zApplicationDraft,
    profile: zStudentProfileView,
    choices: z.array(zApplicationChoice),
    transmissionLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
    withdrawalOnAcceptance: z.string(),
    disabilityDocument: z.union([
        z.string(),
        z.null()
    ]),
    sections: z.object({
        personal: zApplicationSectionState,
        enrollment: zApplicationSectionState,
        economic: zApplicationSectionState,
        residences: zApplicationSectionState,
        declarations_and_documents: zApplicationSectionState,
        summary: zApplicationSectionState
    }),
    declarations: z.array(zApplicationDeclaration),
    documents: z.array(zApplicationDocument),
    warnings: z.array(zApplicationWarning),
    eligibility: z.array(zEligibilityForVersion),
    notices: z.array(z.enum(['no_quota_left'])),
    unreadNotices: z.array(zApplicationUnreadNotice),
    currentSection: z.enum([
        'personal',
        'enrollment',
        'economic',
        'residences',
        'declarations_and_documents',
        'summary'
    ])
});

export const zConfirmWarnings = z.object({
    warningIds: z.array(z.string()).max(50)
});

export const zApplicationUpdate = z.object({
    roomPreference: z.optional(z.enum([
        'single',
        'double',
        'none'
    ])),
    excludeQ70: z.optional(z.boolean()),
    needsEquipped: z.optional(z.boolean()),
    privacyNoticeAccepted: z.optional(z.literal(true))
});

export const zApplicationUpdatedView = z.object({
    application: zApplicationDraft,
    profile: zStudentProfileView,
    choices: z.array(zApplicationChoice),
    transmissionLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
    withdrawalOnAcceptance: z.string(),
    disabilityDocument: z.union([
        z.string(),
        z.null()
    ]),
    sections: z.object({
        personal: zApplicationSectionState,
        enrollment: zApplicationSectionState,
        economic: zApplicationSectionState,
        residences: zApplicationSectionState,
        declarations_and_documents: zApplicationSectionState,
        summary: zApplicationSectionState
    }),
    declarations: z.array(zApplicationDeclaration),
    documents: z.array(zApplicationDocument),
    warnings: z.array(zApplicationWarning),
    eligibility: z.array(zEligibilityForVersion),
    notices: z.array(z.enum(['no_quota_left'])),
    unreadNotices: z.array(zApplicationUnreadNotice),
    currentSection: z.enum([
        'personal',
        'enrollment',
        'economic',
        'residences',
        'declarations_and_documents',
        'summary'
    ]),
    removedResidences: z.array(z.string())
});

export const zPresignedPutUpload = z.object({
    method: z.enum(['PUT']),
    url: z.string(),
    headers: z.record(z.string(), z.string())
});

export const zPresignedPostUpload = z.object({
    method: z.enum(['POST']),
    url: z.string(),
    fields: z.record(z.string(), z.string())
});

export const zPresignedUpload = z.union([
    z.object({
        method: z.literal('PUT')
    }).and(zPresignedPutUpload),
    z.object({
        method: z.literal('POST')
    }).and(zPresignedPostUpload)
]);

export const zCreatedAsset = z.object({
    id: z.string(),
    upload: zPresignedUpload
});

export const zAssetMimeTypeNotAllowed = z.object({
    code: z.enum(['asset_mime_type_not_allowed']),
    message: z.string()
});

export const zAssetSizeTooLarge = z.object({
    code: z.enum(['asset_size_too_large']),
    message: z.string()
});

export const zAssetContentMismatch = z.object({
    code: z.enum(['asset_content_mismatch']),
    message: z.string()
});

export const zAssetScopeInvalid = z.object({
    code: z.enum(['asset_scope_invalid']),
    message: z.string()
});

export const zUserBanned = z.object({
    code: z.enum(['user_banned']),
    message: z.string()
});

export const zAuthCsrfInvalid = z.object({
    code: z.enum(['auth_csrf_invalid']),
    message: z.string()
});

export const zAssetOwnershipError = z.object({
    code: z.enum(['asset_ownership_error']),
    message: z.string()
});

export const zSetDeclarations = z.object({
    offSite: z.optional(z.boolean()),
    noDebts: z.optional(z.boolean()),
    noConvictions: z.optional(z.boolean()),
    noIncompatibleIllness: z.optional(z.boolean())
});

export const zApplicationReadiness = z.object({
    ready: z.boolean(),
    missing: z.array(z.string())
});

export const zAvailableCourse = z.object({
    institutionName: z.string(),
    placeName: z.string(),
    maxDistanceKm: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zAvailableResidence = z.object({
    residenceId: z.string(),
    slug: z.string(),
    name: z.string(),
    city: z.string(),
    minRateCents: z.object({
        q30: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        q70: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    academicYear: zAcademicYear,
    closeAt: zInstantOutput,
    intake: z.enum(['open', 'remaining']),
    hasEquippedSeats: z.boolean(),
    admittedInstitutions: z.array(z.string()),
    admitsStudent: z.boolean(),
    distanceKm: z.union([
        z.number().gte(0),
        z.null()
    ]),
    nearCourse: z.boolean(),
    chosen: z.boolean()
});

export const zAvailableResidences = z.object({
    course: z.union([
        z.object({
            institutionName: z.string(),
            placeName: z.string(),
            maxDistanceKm: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ]),
    residences: z.array(zAvailableResidence)
});

export const zAuthCredentialsMissing = z.object({
    code: z.enum(['auth_credentials_missing']),
    message: z.string()
});

export const zAuthJwtInvalid = z.object({
    code: z.enum(['auth_jwt_invalid']),
    message: z.string()
});

export const zUserSessionInvalid = z.object({
    code: z.enum(['session_invalid']),
    message: z.string()
});

export const zUserSessionExpired = z.object({
    code: z.enum(['session_expired']),
    message: z.string()
});

export const zUserDeleted = z.object({
    code: z.enum(['user_deleted']),
    message: z.string()
});

export const zStudentVerification = z.object({
    flagId: z.string(),
    code: z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ]),
    status: z.enum([
        'in_review',
        'clarification_requested',
        'not_admitted',
        'corrected'
    ]),
    quotas: z.array(z.enum(['q30', 'q70'])),
    cause: z.union([
        z.string(),
        z.null()
    ]),
    stillIn: z.nullable(z.enum(['q30', 'q70'])),
    clarificationDueAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zApplicationSubmissionSummary = z.object({
    id: z.string(),
    origin: z.enum(['platform', 'direct_pec']),
    applicationId: z.union([
        z.string(),
        z.null()
    ]),
    residence: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string()
    }),
    academicYear: zAcademicYear,
    protocol: z.string(),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    submittedAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival'])),
    transmissionState: z.nullable(z.enum([
        'sending',
        'delivered',
        'not_delivered'
    ])),
    reviewState: z.nullable(z.enum([
        'awaiting',
        'acknowledged',
        'problem'
    ])),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewProblemCause: z.nullable(z.enum([
        'missing_signature',
        'annex_mismatch',
        'annex_unreadable',
        'identity_document_problem'
    ])),
    reviewProblemNote: z.union([
        z.string(),
        z.null()
    ]),
    callCloseAt: zInstantOutput,
    canWithdraw: z.boolean(),
    canReplace: z.boolean(),
    supersededByProtocol: z.union([
        z.string(),
        z.null()
    ]),
    verification: z.array(zStudentVerification)
});

export const zApplicationSubmissionDetail = z.object({
    id: z.string(),
    origin: z.enum(['platform', 'direct_pec']),
    applicationId: z.union([
        z.string(),
        z.null()
    ]),
    residence: z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string()
    }),
    academicYear: zAcademicYear,
    protocol: z.string(),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    submittedAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival'])),
    transmissionState: z.nullable(z.enum([
        'sending',
        'delivered',
        'not_delivered'
    ])),
    reviewState: z.nullable(z.enum([
        'awaiting',
        'acknowledged',
        'problem'
    ])),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewProblemCause: z.nullable(z.enum([
        'missing_signature',
        'annex_mismatch',
        'annex_unreadable',
        'identity_document_problem'
    ])),
    reviewProblemNote: z.union([
        z.string(),
        z.null()
    ]),
    callCloseAt: zInstantOutput,
    canWithdraw: z.boolean(),
    canReplace: z.boolean(),
    supersededByProtocol: z.union([
        z.string(),
        z.null()
    ]),
    verification: z.array(zStudentVerification),
    history: z.array(z.object({
        type: z.enum([
            'submitted',
            'acknowledged',
            'problem_reported',
            'received_by_pec',
            'transcription_corrected',
            'superseded',
            'withdrawn'
        ]),
        at: zInstantOutput
    })),
    files: z.array(z.object({
        id: z.string(),
        kind: z.enum([
            'signed_annex_a',
            'document',
            'direct_message'
        ]),
        documentKind: z.nullable(z.enum([
            'identity',
            'enrollment',
            'iseeu_ispeu',
            'credits_screenshot',
            'doctoral_enrollment',
            'disability'
        ])),
        filename: z.string(),
        sha256: z.string(),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
    }))
});

export const zRequirementFlagFacts = z.union([
    z.object({
        code: z.enum(['iseeu_above']),
        declaredValue: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ]),
        threshold: z.object({
            q30Cents: z.int().gte(0).lte(9007199254740991),
            q70Cents: z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ])
        })
    }),
    z.object({
        code: z.enum(['ispeu_above']),
        declaredValue: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ]),
        threshold: z.object({
            q30Cents: z.int().gte(0).lte(9007199254740991),
            q70Cents: z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ])
        })
    }),
    z.object({
        code: z.enum(['cfu_below_min']),
        declaredValue: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ]),
        threshold: z.object({
            credits: z.int().gt(0).lte(9007199254740991)
        })
    }),
    z.object({
        code: z.enum(['offsite_not_met']),
        declaredValue: z.nullable(z.enum([
            'off_site',
            'commuter',
            'in_site'
        ])),
        threshold: z.unknown()
    })
]);

export const zStudentClarification = z.object({
    flagId: z.string(),
    residenceName: z.string(),
    code: z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ]),
    facts: zRequirementFlagFacts,
    question: z.string(),
    askedAt: zInstantOutput,
    dueAt: zInstantOutput,
    state: z.enum([
        'open',
        'awaiting_clarification',
        'clarification_received',
        'clarification_expired',
        'resolved_confirmed',
        'resolved_corrected'
    ]),
    answer: z.union([
        z.object({
            text: z.string(),
            fileName: z.union([
                z.string(),
                z.null()
            ]),
            answeredAt: zInstantOutput
        }),
        z.null()
    ]),
    expiredAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zApplicationManagerRow = z.object({
    id: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.union([
        z.string(),
        z.null()
    ]),
    firstName: z.union([
        z.string(),
        z.null()
    ]),
    category: z.union([
        z.string(),
        z.null()
    ]),
    quotas: z.object({
        q30: z.boolean(),
        q70: z.boolean()
    }),
    iseeuCents: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    credits: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    origin: z.enum(['platform', 'direct_pec']),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    submittedAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival'])),
    transmissionState: z.nullable(z.enum([
        'sending',
        'delivered',
        'not_delivered'
    ])),
    reviewState: z.nullable(z.enum([
        'awaiting',
        'acknowledged',
        'problem'
    ])),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewProblemCause: z.nullable(z.enum([
        'missing_signature',
        'annex_mismatch',
        'annex_unreadable',
        'identity_document_problem'
    ])),
    reviewProblemNote: z.union([
        z.string(),
        z.null()
    ]),
    supersededByProtocol: z.union([
        z.string(),
        z.null()
    ]),
    withdrawnAt: z.union([
        z.string(),
        z.null()
    ]),
    withdrawalCause: z.nullable(z.enum(['student_request', 'accepted_elsewhere'])),
    unseenNotice: z.nullable(z.enum([
        'replacement',
        'withdrawal',
        'restored'
    ])),
    openFlagCodes: z.array(z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ])),
    afterCall: z.boolean()
});

export const zApplicationManagerSnapshot = z.object({
    schemaVersion: z.literal(1),
    frozenAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    email: z.string(),
    student: z.object({
        lastName: z.union([
            z.string(),
            z.null()
        ]),
        firstName: z.union([
            z.string(),
            z.null()
        ]),
        birthDate: z.union([
            z.string(),
            z.null()
        ]),
        birthMunicipalityIstatCode: z.union([
            z.string(),
            z.null()
        ]),
        birthCountryCode: z.union([
            z.string(),
            z.null()
        ]),
        birthPlace: z.union([
            z.string(),
            z.null()
        ]),
        taxCode: z.union([
            z.string(),
            z.null()
        ]),
        passportNumber: z.union([
            z.string(),
            z.null()
        ]),
        phone: z.union([
            z.string(),
            z.null()
        ]),
        familyAbroad: z.boolean(),
        residenceAddress: z.union([
            z.string(),
            z.null()
        ]),
        residencePostalCode: z.union([
            z.string(),
            z.null()
        ]),
        residenceMunicipalityIstatCode: z.union([
            z.string(),
            z.null()
        ]),
        residenceCountryCode: z.union([
            z.string(),
            z.null()
        ]),
        residencePlace: z.union([
            z.string(),
            z.null()
        ])
    }),
    enrollment: z.object({
        institutionCode: z.union([
            z.string(),
            z.null()
        ]),
        institutionName: z.union([
            z.string(),
            z.null()
        ]),
        campusCode: z.union([
            z.string(),
            z.null()
        ]),
        campusPlace: z.union([
            z.string(),
            z.null()
        ]),
        courseName: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        campusAddress: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        courseType: z.union([
            z.string(),
            z.null()
        ]),
        enrollmentYear: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        studentNumber: z.union([
            z.string(),
            z.null()
        ]),
        preEnrollmentNumber: z.union([
            z.string(),
            z.null()
        ]),
        credits: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        extraSemester: z.boolean(),
        gradeAverage: z.optional(z.union([
            z.number(),
            z.null()
        ]))
    }),
    economic: z.object({
        iseeuCents: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        ispeuCents: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    preferences: z.object({
        roomPreference: z.enum([
            'single',
            'double',
            'none'
        ]),
        excludeQ70: z.boolean(),
        needsEquipped: z.boolean()
    }),
    declarations: z.array(z.object({
        code: z.enum([
            'off_site',
            'no_debts',
            'no_convictions',
            'no_incompatible_illness'
        ]),
        madeAt: z.union([
            z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            z.null()
        ]),
        legalTextCode: z.string(),
        text: z.string(),
        rulesVersionId: z.int().gte(-9007199254740991).lte(9007199254740991)
    })),
    documents: z.array(z.object({
        kind: z.enum([
            'identity',
            'enrollment',
            'iseeu_ispeu',
            'credits_screenshot',
            'doctoral_enrollment',
            'disability'
        ])
    })),
    residence: z.object({
        residenceId: z.string(),
        callId: z.string(),
        slug: z.string(),
        name: z.string(),
        address: z.string(),
        city: z.string(),
        operatorLegalName: z.string(),
        pecAddress: z.string(),
        callCloseAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        rulesVersionId: z.int().gte(-9007199254740991).lte(9007199254740991),
        rulesFingerprint: z.string(),
        category: z.union([
            z.string(),
            z.null()
        ]),
        quotas: z.object({
            q30: z.object({
                eligible: z.boolean(),
                reason: z.enum([
                    'ok',
                    'iseeu_above',
                    'ispeu_above',
                    'offsite_not_met',
                    'cfu_below_min',
                    'missing_data',
                    'excluded_by_student'
                ])
            }),
            q70: z.object({
                eligible: z.boolean(),
                reason: z.enum([
                    'ok',
                    'iseeu_above',
                    'ispeu_above',
                    'offsite_not_met',
                    'cfu_below_min',
                    'missing_data',
                    'excluded_by_student'
                ])
            })
        }),
        offSite: z.union([
            z.object({
                status: z.enum([
                    'off_site',
                    'commuter',
                    'in_site'
                ]),
                reason: z.enum([
                    'family_abroad',
                    'listed_off_site',
                    'outside_region',
                    'outside_province',
                    'listed_commuter',
                    'distance',
                    'same_area'
                ]),
                provisional: z.boolean(),
                distanceKm: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]),
        warnings: z.array(z.object({
            code: z.enum([
                'iseeu_above',
                'ispeu_above',
                'cfu_below_min',
                'offsite_not_met'
            ]),
            value: z.union([
                z.number(),
                z.string()
            ]),
            confirmedAt: z.union([
                z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                z.null()
            ])
        }))
    })
});

export const zApplicationManagerDetail = z.object({
    id: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    origin: z.enum(['platform', 'direct_pec']),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    submittedAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveAt: z.union([
        z.string(),
        z.null()
    ]),
    effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival'])),
    withdrawnAt: z.union([
        z.string(),
        z.null()
    ]),
    withdrawalCause: z.nullable(z.enum(['student_request', 'accepted_elsewhere'])),
    supersededByProtocol: z.union([
        z.string(),
        z.null()
    ]),
    transmissionState: z.nullable(z.enum([
        'sending',
        'delivered',
        'not_delivered'
    ])),
    reviewState: z.nullable(z.enum([
        'awaiting',
        'acknowledged',
        'problem'
    ])),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewProblemCause: z.nullable(z.enum([
        'missing_signature',
        'annex_mismatch',
        'annex_unreadable',
        'identity_document_problem'
    ])),
    reviewProblemNote: z.union([
        z.string(),
        z.null()
    ]),
    disabilityPriority: z.nullable(z.enum(['held', 'revoked'])),
    transmission: z.union([
        z.object({
            to: z.string(),
            subject: z.string(),
            checkCode: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    callCloseAt: zInstantOutput,
    direct: z.union([
        z.object({
            messageKind: z.enum(['eml', 'pdf']),
            arrivedAt: zInstantOutput,
            senderAddress: z.string(),
            senderKind: z.enum(['pec', 'email']),
            uploadedAt: zInstantOutput,
            uploadedBy: z.object({
                id: z.string(),
                name: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            pecReplySentAt: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    corrections: z.array(z.object({
        field: z.string(),
        before: z.union([
            z.string(),
            z.number(),
            z.boolean(),
            z.null()
        ]),
        after: z.union([
            z.string(),
            z.number(),
            z.boolean(),
            z.null()
        ]),
        by: z.object({
            id: z.string(),
            name: z.union([
                z.string(),
                z.null()
            ])
        }),
        at: zInstantOutput
    })),
    flags: z.array(z.object({
        id: z.string(),
        code: z.enum([
            'iseeu_above',
            'ispeu_above',
            'cfu_below_min',
            'offsite_not_met'
        ]),
        state: z.enum([
            'open',
            'awaiting_clarification',
            'clarification_received',
            'clarification_expired',
            'resolved_confirmed',
            'resolved_corrected'
        ])
    })),
    data: zApplicationManagerSnapshot,
    history: z.array(z.object({
        type: z.enum([
            'submitted',
            'acknowledged',
            'problem_reported',
            'received_by_pec',
            'transcription_corrected',
            'superseded',
            'withdrawn'
        ]),
        at: zInstantOutput
    })),
    files: z.array(z.object({
        id: z.string(),
        kind: z.enum([
            'signed_annex_a',
            'document',
            'direct_message'
        ]),
        documentKind: z.nullable(z.enum([
            'identity',
            'enrollment',
            'iseeu_ispeu',
            'credits_screenshot',
            'doctoral_enrollment',
            'disability'
        ])),
        filename: z.string(),
        sha256: z.string(),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
    }))
});

export const zApplicationSendingCounters = z.object({
    sent: z.int().gte(-9007199254740991).lte(9007199254740991),
    delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
    notDelivered: z.int().gte(-9007199254740991).lte(9007199254740991),
    acknowledged: z.int().gte(-9007199254740991).lte(9007199254740991),
    withProblem: z.int().gte(-9007199254740991).lte(9007199254740991),
    awaitingReview: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zApplicationManagerCounters = z.object({
    sending: zApplicationSendingCounters,
    byState: z.object({
        submitted: z.int().gte(-9007199254740991).lte(9007199254740991),
        superseded: z.int().gte(-9007199254740991).lte(9007199254740991),
        withdrawn: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    byCategory: z.object({
        first_year: z.int().gte(-9007199254740991).lte(9007199254740991),
        later_years: z.int().gte(-9007199254740991).lte(9007199254740991),
        doctoral_and_specialization: z.int().gte(-9007199254740991).lte(9007199254740991),
        unknown: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    byQuota: z.object({
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    withOpenFlags: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zApplicationManagerDashboard = z.object({
    totals: z.object({
        received: z.int().gte(-9007199254740991).lte(9007199254740991),
        receivedLast7Days: z.int().gte(-9007199254740991).lte(9007199254740991),
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991),
        byCategory: z.object({
            first_year: z.int().gte(-9007199254740991).lte(9007199254740991),
            later_years: z.int().gte(-9007199254740991).lte(9007199254740991),
            doctoral_and_specialization: z.int().gte(-9007199254740991).lte(9007199254740991),
            unknown: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        seats: z.object({
            q30: z.int().gte(-9007199254740991).lte(9007199254740991),
            q70: z.int().gte(-9007199254740991).lte(9007199254740991),
            total: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }),
    daily: z.array(z.object({
        day: z.string(),
        received: z.int().gte(-9007199254740991).lte(9007199254740991)
    })),
    residences: z.array(z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
        call: z.object({
            state: z.enum([
                'draft',
                'published',
                'open',
                'closed'
            ]),
            academicYear: z.string(),
            closeAt: z.union([
                z.string(),
                z.null()
            ])
        }),
        received: z.int().gte(-9007199254740991).lte(9007199254740991),
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991),
        byCategory: z.object({
            first_year: z.int().gte(-9007199254740991).lte(9007199254740991),
            later_years: z.int().gte(-9007199254740991).lte(9007199254740991),
            doctoral_and_specialization: z.int().gte(-9007199254740991).lte(9007199254740991),
            unknown: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        seats: z.object({
            q30: z.int().gte(-9007199254740991).lte(9007199254740991),
            q70: z.int().gte(-9007199254740991).lte(9007199254740991),
            total: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }))
});

export const zApplicationManagerStatus = z.object({
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    withdrawnAt: z.union([
        z.string(),
        z.null()
    ]),
    withdrawalCause: z.nullable(z.enum(['student_request', 'accepted_elsewhere'])),
    supersededByProtocol: z.union([
        z.string(),
        z.null()
    ])
});

export const zApplicationReviewResult = z.object({
    reviewState: z.enum([
        'awaiting',
        'acknowledged',
        'problem'
    ]),
    reviewedAt: zInstantOutput,
    reviewProblemCause: z.nullable(z.enum([
        'missing_signature',
        'annex_mismatch',
        'annex_unreadable',
        'identity_document_problem'
    ])),
    reviewProblemNote: z.union([
        z.string(),
        z.null()
    ])
});

export const zDirectMessageReading = z.object({
    arrivedAt: z.union([
        z.string(),
        z.null()
    ]),
    senderAddress: z.union([
        z.string(),
        z.null()
    ]),
    senderKind: z.nullable(z.enum(['pec', 'email'])),
    source: z.enum([
        'daticert',
        'headers',
        'none'
    ])
});

export const zSamePersonSubmission = z.object({
    id: z.string(),
    protocol: z.string(),
    origin: z.enum(['platform', 'direct_pec']),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    effectiveAt: z.union([
        z.string(),
        z.null()
    ]),
    sentAt: zInstantOutput
});

export const zFloatingDate = z.string();

export const zDirectTranscription = z.object({
    lastName: z.string().min(1).max(100),
    firstName: z.string().min(1).max(100),
    birthDate: zFloatingDate,
    birthMunicipalityIstatCode: z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ]),
    birthCountryCode: z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ]),
    taxCode: z.union([
        z.string().regex(/^[A-Za-z0-9]{16}$/),
        z.null()
    ]),
    passportNumber: z.optional(z.union([
        z.string().min(5).max(30),
        z.null()
    ])),
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    phone: z.union([
        z.string().regex(/^\+[1-9]\d{6,14}$/),
        z.null()
    ]),
    familyAbroad: z.boolean(),
    residenceAddress: z.string().min(1).max(200),
    residencePostalCode: z.union([
        z.string().regex(/^\d{5}$/),
        z.null()
    ]),
    residenceMunicipalityIstatCode: z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ]),
    residenceCountryCode: z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ]),
    institutionCode: z.string().min(1).max(10),
    campusCode: z.string().min(1).max(20),
    courseName: z.string().min(1).max(200),
    campusAddress: z.string().min(1).max(200),
    courseType: z.enum([
        'bachelor',
        'master',
        'single_cycle',
        'phd',
        'specialization'
    ]),
    enrollmentYear: z.int().gte(1).lte(6),
    studentNumber: z.union([
        z.string().min(1).max(30),
        z.null()
    ]),
    preEnrollmentNumber: z.union([
        z.string().min(1).max(30),
        z.null()
    ]),
    credits: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    extraSemester: z.boolean(),
    gradeAverage: z.union([
        z.number().gte(18).lte(30),
        z.null()
    ]),
    iseeuCents: z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ]),
    ispeuCents: z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ]),
    roomPreference: z.enum([
        'single',
        'double',
        'none'
    ]),
    excludeQ70: z.boolean(),
    needsEquipped: z.boolean(),
    declarations: z.object({
        offSite: z.boolean(),
        noDebts: z.boolean(),
        noConvictions: z.boolean(),
        noIncompatibleIllness: z.boolean()
    })
});

export const zDirectRegistration = z.object({
    id: z.string(),
    protocol: z.string(),
    state: z.enum([
        'submitted',
        'superseded',
        'withdrawn'
    ]),
    replaces: z.union([
        z.string(),
        z.null()
    ]),
    supersededBy: z.union([
        z.string(),
        z.null()
    ]),
    pecReply: z.union([
        z.object({
            subject: z.string(),
            text: z.string()
        }),
        z.null()
    ])
});

export const zGetSessionSessionBlock = z.object({
    expiresAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    creationSource: z.string()
});

export const zAuthIdentity = z.object({
    id: z.string()
});

export const zOtpIssuanceThrottled = z.object({
    code: z.enum(['otp_issuance_throttled']),
    message: z.string(),
    retryAfterSeconds: z.int().gt(0).lte(9007199254740991)
});

export const zOtpRateLimited = z.object({
    code: z.enum(['otp_rate_limited']),
    message: z.string(),
    retryAfter: z.int().gt(0).lte(9007199254740991)
});

export const zOtpLocked = z.object({
    code: z.enum(['otp_locked']),
    message: z.string(),
    lockedUntil: zInstantOutput
});

export const zOtpInvalid = z.object({
    code: z.enum(['otp_invalid']),
    message: z.string(),
    attemptsLeft: z.int().gte(0).lte(9007199254740991)
});

export const zOtpExpired = z.object({
    code: z.enum(['otp_expired']),
    message: z.string()
});

export const zEmailOtpTokenInvalid = z.object({
    code: z.enum(['email_otp_token_invalid']),
    message: z.string()
});

export const zStatusSuccessResponse = z.object({
    status: z.enum(['success'])
});

export const zDeleteAccountRequiresOtp = z.object({
    status: z.enum(['requires_otp']),
    emailOtpToken: z.string()
});

export const zBackofficeAdminIdentity = z.object({
    id: z.string(),
    role: z.enum(['general_admin', 'facility_manager']),
    residenceIds: z.array(z.string())
});

export const zPassword = z.string();

export const zBackofficeChangePasswordOtpInvalid = z.object({
    code: z.enum(['backoffice_change_password_otp_invalid']),
    message: z.string()
});

export const zBackofficeNoChangePasswordMethodAvailable = z.object({
    code: z.enum(['backoffice_no_change_password_method_available']),
    message: z.string()
});

export const zBackofficeAuthCredentialsMissing = z.object({
    code: z.enum(['backoffice_auth_credentials_missing']),
    message: z.string()
});

export const zBackofficeJwtInvalid = z.object({
    code: z.enum(['backoffice_jwt_invalid']),
    message: z.string()
});

export const zBackofficeSessionInvalid = z.object({
    code: z.enum(['backoffice_session_invalid']),
    message: z.string()
});

export const zBackofficeSessionExpired = z.object({
    code: z.enum(['backoffice_session_expired']),
    message: z.string()
});

export const zBackofficeAdminDeleted = z.object({
    code: z.enum(['backoffice_admin_deleted']),
    message: z.string()
});

export const zBackofficeEmailOtpTokenInvalid = z.object({
    code: z.enum(['backoffice_email_otp_token_invalid']),
    message: z.string()
});

export const zBackofficeAdminStatus = z.enum([
    'pending',
    'active',
    'disabled'
]);

export const zBackofficeAdmin = z.object({
    id: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    name: z.union([
        z.string(),
        z.null()
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])),
    disabledAt: z.union([
        z.string(),
        z.null()
    ]),
    emailVerifiedAt: z.union([
        z.string(),
        z.null()
    ]),
    status: zBackofficeAdminStatus,
    abilities: z.array(z.enum([
        'users.manage',
        'admins.manage',
        'residences.manage',
        'call.manage',
        'event_log.read',
        'email_texts.manage',
        'sending.monitor',
        'call.monitor',
        'support.manage'
    ])),
    createdAt: zInstantOutput
});

export const zBackofficeSelfEditForbidden = z.object({
    code: z.enum(['backoffice_self_edit_forbidden']),
    message: z.string()
});

export const zBackofficeListSessionsFilters = z.object({
    status: z.optional(z.union([
        z.array(z.enum([
            'active',
            'revoked',
            'expired'
        ])).min(1).max(3),
        z.null()
    ]))
});

export const zBackofficeSessionListItem = z.object({
    id: z.string(),
    ipAddress: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    device: z.union([
        z.object({
            browser: zSessionDeviceBrowser,
            os: zSessionDeviceOs,
            device: zSessionDeviceInfo,
            engine: zSessionDeviceEngine
        }),
        z.null()
    ]),
    creationSource: z.enum([
        'password',
        'password_reset',
        'invite_accept'
    ]),
    status: z.enum([
        'active',
        'revoked',
        'expired'
    ]),
    isCurrent: z.boolean(),
    createdAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    expiresAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zBackofficeAdminProfile = z.object({
    id: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    name: z.union([
        z.string(),
        z.null()
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ]))
});

export const zBackofficeGetSessionSessionBlock = z.object({
    expiresAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    creationSource: z.enum([
        'password',
        'password_reset',
        'invite_accept'
    ])
});

export const zPublicationCheck = z.object({
    condition: z.enum([
        'dates',
        'mailboxTest',
        'rateReferences',
        'sites',
        'privacyContacts',
        'dataValid',
        'dataConfirmed'
    ]),
    met: z.boolean(),
    blocker: z.nullable(z.enum([
        'dates_missing',
        'start_in_past',
        'end_before_start',
        'mailbox_test_not_ready',
        'rate_references_missing',
        'sites_incomplete',
        'privacy_contacts_missing',
        'data_invalid',
        'data_not_confirmed'
    ]))
});

export const zManagedCallSummary = z.object({
    residence: z.object({
        id: z.string(),
        name: z.string(),
        city: z.string(),
        cover: z.union([
            z.object({
                url: z.string(),
                blurhash: z.union([
                    z.string(),
                    z.null()
                ]),
                width: z.union([
                    z.int().gte(-9007199254740991).lte(9007199254740991),
                    z.null()
                ]),
                height: z.union([
                    z.int().gte(-9007199254740991).lte(9007199254740991),
                    z.null()
                ]),
                variants: z.union([
                    z.object({
                        original: z.optional(z.string()),
                        thumbnail: z.optional(z.string()),
                        small: z.optional(z.string()),
                        medium: z.optional(z.string()),
                        large: z.optional(z.string())
                    }),
                    z.null()
                ])
            }),
            z.null()
        ])
    }),
    call: z.object({
        id: z.string(),
        academicYear: zAcademicYear,
        readOnly: z.boolean(),
        state: z.enum([
            'draft',
            'published',
            'open',
            'closed'
        ]),
        startAt: z.union([
            z.string(),
            z.null()
        ]),
        endDay: z.union([
            z.string(),
            z.null()
        ]),
        closeAt: z.union([
            z.string(),
            z.null()
        ]),
        publishedAt: z.union([
            z.string(),
            z.null()
        ]),
        publication: z.array(zPublicationCheck)
    }),
    unseenNotices: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zCallRulesMeritThreshold = z.object({
    key: z.string().min(1),
    courseType: z.nullable(z.enum([
        'bachelor',
        'single_cycle',
        'master'
    ])),
    description: z.string().min(1),
    minCredits: z.int().gte(0).lte(9007199254740991),
    maxCredits: z.optional(z.int().gt(0).lte(9007199254740991))
});

export const zCallRulesMunicipality = z.object({
    istatCode: z.string().regex(/^\d{6}$/),
    name: z.string().min(1)
});

export const zCallRulesCategory = z.object({
    code: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    description: z.string().min(1),
    ranking: z.array(z.enum([
        'iseeu_asc',
        'age_asc',
        'credits_desc',
        'submitted_at_asc',
        'protocol_asc'
    ])).min(1)
});

export const zCallRulesLegalText = z.object({
    code: z.enum([
        'E9',
        'P1',
        'P2',
        'P3',
        'P4',
        'DECL_OFF_SITE',
        'DECL_NO_DEBTS',
        'DECL_NO_CONVICTIONS',
        'DECL_NO_INCOMPATIBLE_ILLNESS',
        'DPR445_NOTICE',
        'DATA_AUTHORIZATION',
        'WITHDRAWAL_ON_ACCEPTANCE',
        'MANDATE',
        'COURSE_SITE',
        'REQUEST',
        'T1',
        'T2',
        'T3',
        'T4'
    ]),
    name: z.string().min(1),
    subject: z.string().min(1),
    body: z.string().min(1),
    requiredVariables: z.array(z.string().min(1))
});

export const zCallRules = z.object({
    quota30: z.object({
        minSeatsPercent: z.object({
            value: z.int().gte(1).lte(100),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        iseeuMaxCents: z.object({
            value: z.int().gte(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        ispeuMaxCents: z.object({
            value: z.int().gte(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    }),
    quota70: z.object({
        iseeuMaxCents: z.object({
            value: z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        ispeuMaxCents: z.object({
            value: z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        creditsRequired: z.optional(z.object({
            value: z.boolean(),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }))
    }),
    merit: z.object({
        thresholds: z.object({
            value: z.array(zCallRulesMeritThreshold).min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        singleCycleExtraSemesterCredits: z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        singleCycleExtraSemesterMaxCredits: z.optional(z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })),
        referenceDay: z.object({
            value: z.string().regex(/^\d{2}-\d{2}$/),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        exemptCategories: z.object({
            value: z.array(z.enum([
                'first_year',
                'later_years',
                'doctoral_and_specialization'
            ])),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    }),
    offSite: z.object({
        lists: z.object({
            rome: z.object({
                offSite: z.object({
                    value: z.array(zCallRulesMunicipality),
                    status: z.enum([
                        'fissato',
                        'da_compilare',
                        'da_decidere',
                        'da_verificare'
                    ]),
                    source: z.string().min(1)
                }),
                commuter: z.object({
                    value: z.array(zCallRulesMunicipality),
                    status: z.enum([
                        'fissato',
                        'da_compilare',
                        'da_decidere',
                        'da_verificare'
                    ]),
                    source: z.string().min(1)
                })
            }),
            cassino: z.object({
                offSite: z.object({
                    value: z.array(zCallRulesMunicipality),
                    status: z.enum([
                        'fissato',
                        'da_compilare',
                        'da_decidere',
                        'da_verificare'
                    ]),
                    source: z.string().min(1)
                }),
                commuter: z.object({
                    value: z.array(zCallRulesMunicipality),
                    status: z.enum([
                        'fissato',
                        'da_compilare',
                        'da_decidere',
                        'da_verificare'
                    ]),
                    source: z.string().min(1)
                })
            }),
            viterbo: z.object({
                offSite: z.object({
                    value: z.array(zCallRulesMunicipality),
                    status: z.enum([
                        'fissato',
                        'da_compilare',
                        'da_decidere',
                        'da_verificare'
                    ]),
                    source: z.string().min(1)
                })
            })
        }),
        otherSitesMinDistanceKm: z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    }),
    categories: z.object({
        list: z.object({
            value: z.tuple([
                zCallRulesCategory,
                zCallRulesCategory,
                zCallRulesCategory
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        tieBreak: z.object({
            value: z.union([
                z.array(z.enum([
                    'iseeu_asc',
                    'age_asc',
                    'credits_desc',
                    'submitted_at_asc',
                    'protocol_asc'
                ])),
                z.null()
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        seatSplit: z.object({
            value: z.union([
                z.array(z.object({
                    category: z.enum([
                        'first_year',
                        'later_years',
                        'doctoral_and_specialization'
                    ]),
                    percent: z.int().gte(0).lte(100)
                })),
                z.null()
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        unfilledSeatsOrder: z.object({
            value: z.union([
                z.array(z.enum([
                    'first_year',
                    'later_years',
                    'doctoral_and_specialization'
                ])),
                z.null()
            ]),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        seatMethod: z.optional(z.object({
            value: z.object({
                rounding: z.enum(['largest_remainder']),
                scope: z.enum(['per_quota']),
                ties: z.enum(['category_list_order']),
                q30Recovery: z.boolean()
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }))
    }),
    dsuRanking: z.optional(z.object({
        freshersShare: z.object({
            value: z.object({
                percent: z.int().gte(0).lte(100),
                rounding: z.enum(['up'])
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        weights: z.object({
            value: z.object({
                freshers: z.object({
                    credits: z.int().gte(0).lte(9007199254740991),
                    grade: z.int().gte(0).lte(9007199254740991),
                    income: z.int().gte(0).lte(9007199254740991)
                }),
                laterYears: z.object({
                    credits: z.int().gte(0).lte(9007199254740991),
                    grade: z.int().gte(0).lte(9007199254740991),
                    income: z.int().gte(0).lte(9007199254740991)
                }),
                doctoral: z.object({
                    credits: z.int().gte(0).lte(9007199254740991),
                    grade: z.int().gte(0).lte(9007199254740991),
                    income: z.int().gte(0).lte(9007199254740991)
                })
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        decimals: z.object({
            value: z.int().gte(0).lte(6),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        grade: z.object({
            value: z.object({
                min: z.int().gt(0).lte(9007199254740991),
                max: z.int().gt(0).lte(9007199254740991)
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        ties: z.object({
            value: z.object({
                freshers: z.array(z.enum([
                    'iseeu_asc',
                    'age_asc',
                    'credits_desc',
                    'submitted_at_asc',
                    'protocol_asc'
                ])).min(1),
                laterYears: z.array(z.enum([
                    'iseeu_asc',
                    'age_asc',
                    'credits_desc',
                    'submitted_at_asc',
                    'protocol_asc'
                ])).min(1),
                doctoral: z.array(z.enum([
                    'iseeu_asc',
                    'age_asc',
                    'credits_desc',
                    'submitted_at_asc',
                    'protocol_asc'
                ])).min(1),
                betweenLists: z.array(z.enum([
                    'iseeu_asc',
                    'age_asc',
                    'credits_desc',
                    'submitted_at_asc',
                    'protocol_asc'
                ])).min(1)
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    terms: z.object({
        manualIntakeDays: z.object({
            value: z.object({
                days: z.int().gt(0).lte(9007199254740991),
                kind: z.enum(['business', 'calendar'])
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        flagsCloseDays: z.object({
            value: z.object({
                days: z.int().gt(0).lte(9007199254740991),
                kind: z.enum(['business', 'calendar'])
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        clarificationDays: z.object({
            value: z.object({
                days: z.int().gt(0).lte(9007199254740991),
                kind: z.enum(['business', 'calendar'])
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        reviewWindowHours: z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        offerSendWindow: z.object({
            value: z.object({
                weekdays: z.array(z.int().gte(1).lte(7)).min(1),
                from: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
                to: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
                skipHolidays: z.boolean()
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        offerAcceptanceDays: z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        offerReminderHours: z.object({
            value: z.int().gt(0).lte(9007199254740991),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        expiryConfirmDeadline: z.object({
            value: z.object({
                businessDaysAfter: z.int().gt(0).lte(9007199254740991),
                time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/)
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        callCloseTime: z.object({
            value: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    }),
    holidays: z.object({
        value: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).min(1),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ]),
        source: z.string().min(1)
    }),
    clauses: z.object({
        mandateFormula: z.optional(z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })),
        pnrrNotice: z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    }),
    flagCauses: z.optional(z.object({
        value: z.array(z.object({
            code: z.enum([
                'iseeu_documented_above',
                'ispeu_documented_above',
                'cfu_documented_below',
                'offsite_not_met_documented',
                'not_proven_after_clarification',
                'declared_value_differs',
                'document_missing',
                'document_unreadable',
                'document_inconsistent'
            ]),
            outcome: z.enum([
                'not_met',
                'corrected',
                'clarification'
            ]),
            flagCodes: z.array(z.enum([
                'iseeu_above',
                'ispeu_above',
                'cfu_below_min',
                'offsite_not_met'
            ])).min(1),
            text: z.string().min(1)
        })).min(1),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ]),
        source: z.string().min(1)
    })),
    withdrawalCauses: z.optional(z.object({
        value: z.object({
            student_request: z.string().min(1),
            accepted_elsewhere: z.string().min(1)
        }),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ]),
        source: z.string().min(1)
    })),
    offer: z.optional(z.object({
        contractDuration: z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        deposit: z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        payment: z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    equippedSeats: z.optional(z.object({
        minimumPercent: z.object({
            value: z.int().gte(1).lte(100),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        priority: z.object({
            value: z.enum(['within_category_and_quota']),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        unusedSeats: z.object({
            value: z.enum(['general']),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        document: z.object({
            value: z.string().min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        invalidDocumentCause: z.object({
            value: z.object({
                code: z.enum(['disability_document_invalid']),
                text: z.string().min(1)
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    verification: z.optional(z.object({
        items: z.object({
            value: z.array(z.enum([
                'identity',
                'signed_annex',
                'enrollment',
                'economic',
                'credits'
            ])).min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        exclusionCauses: z.object({
            value: z.array(z.object({
                code: z.enum([
                    'identity_document_invalid',
                    'duplicate_application',
                    'annex_not_valid',
                    'enrollment_missing',
                    'iseeu_documented_differs',
                    'ispeu_documented_differs',
                    'cfu_documented_differs'
                ]),
                text: z.string().min(1),
                item: z.enum([
                    'identity',
                    'signed_annex',
                    'enrollment',
                    'economic',
                    'credits'
                ])
            })).min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        }),
        correctionCause: z.object({
            value: z.object({
                code: z.enum(['material_verification_error']),
                text: z.string().min(1)
            }),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    afterAcceptance: z.optional(z.object({
        causes: z.object({
            value: z.array(z.object({
                code: z.enum(['contract_not_signed', 'written_renunciation']),
                text: z.string().min(1)
            })).min(1),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    rooms: z.optional(z.object({
        q30Proportion: z.object({
            value: z.enum(['residence_q30_beds']),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    dsuQuota: z.optional(z.object({
        thresholdPercent: z.object({
            value: z.int().gte(1).lte(100),
            status: z.enum([
                'fissato',
                'da_compilare',
                'da_decidere',
                'da_verificare'
            ]),
            source: z.string().min(1)
        })
    })),
    academicYear: z.optional(z.object({
        value: z.string().regex(/^\d{4}\/\d{4}$/),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ]),
        source: z.string().min(1)
    })),
    legalTexts: z.object({
        value: z.array(zCallRulesLegalText).min(5),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ]),
        source: z.string().min(1)
    })
});

export const zCallRulesVersion = z.object({
    id: z.number(),
    fingerprint: z.string(),
    releasedAt: zInstantOutput,
    rules: zCallRules
});

export const zResidenceSite = z.object({
    id: z.string(),
    name: z.string().min(1).max(200),
    address: z.string().min(1).max(300),
    city: z.string().min(1).max(120),
    typology: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    singleBeds: z.int().gte(0).lte(10000),
    doubleBeds: z.int().gte(0).lte(10000),
    bathroomsCount: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    bathroomsDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    kitchensCount: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    kitchensDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    otherServicesDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedSingleBeds: z.int().gte(0).lte(10000),
    equippedDoubleBeds: z.int().gte(0).lte(10000),
    equippedBathroomsDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedKitchensDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedOtherServicesDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    position: z.int().gte(1).lte(3),
    location: z.union([
        z.object({
            latitude: z.number().gte(35).lte(48),
            longitude: z.number().gte(6).lte(19),
            googlePlaceId: z.union([
                z.string().min(1).max(256),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zResidenceLocation = z.object({
    latitude: z.number().gte(35).lte(48),
    longitude: z.number().gte(6).lte(19),
    googlePlaceId: z.union([
        z.string().min(1).max(256),
        z.null()
    ])
});

export const zResidenceRoomCounts = z.object({
    single: z.number(),
    double: z.number()
});

export const zResidencePhoto = z.object({
    id: z.string(),
    image: z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zResidenceValidationError = z.object({
    field: z.enum([
        'name',
        'operatorLegalName',
        'grantDecree',
        'dpoContact',
        'infoEmail',
        'sites',
        'pecAddress',
        'q30SingleBeds',
        'q30DoubleBeds',
        'q70SingleBeds',
        'q70DoubleBeds',
        'fundedBeds',
        'q70SingleRateCents',
        'q70DoubleRateCents',
        'services',
        'admittedInstitutions',
        'callLinkUrl',
        'contractSigningDays',
        'contractSigningInstructions',
        'depositInstructions',
        'iban',
        'bankAccountHolder'
    ]),
    code: z.enum([
        'no_seats',
        'rate_not_positive',
        'rate_too_low',
        'sites_count_invalid',
        'sites_beds_mismatch',
        'site_equipped_above_beds',
        'equipped_below_minimum',
        'funded_above_total',
        'q30_below_minimum',
        'rate_required',
        'double_beds_odd',
        'site_double_beds_odd',
        'iban_invalid',
        'link_not_https',
        'duplicate_entries',
        'institution_unknown',
        'required',
        'site_typology_required',
        'site_bathrooms_required',
        'site_kitchens_required'
    ]),
    params: z.optional(z.record(z.string(), z.number()))
});

export const zResidence = z.object({
    name: z.string().min(1).max(200),
    operatorLegalName: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    grantDecree: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    dpoContact: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    infoEmail: z.union([
        z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    sites: z.array(zResidenceSite),
    pecAddress: z.union([
        z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    q30SingleBeds: z.int().gte(0).lte(10000),
    q30DoubleBeds: z.int().gte(0).lte(10000),
    q70SingleBeds: z.int().gte(0).lte(10000),
    q70DoubleBeds: z.int().gte(0).lte(10000),
    fundedBeds: z.union([
        z.int().gte(0).lte(10000),
        z.null()
    ]),
    q70SingleRateCents: z.union([
        z.int().gte(0).lte(1000000),
        z.null()
    ]),
    q70DoubleRateCents: z.union([
        z.int().gte(0).lte(1000000),
        z.null()
    ]),
    services: z.array(z.enum([
        'study_room',
        'library',
        'common_kitchen',
        'common_room',
        'laundry',
        'garden',
        'wifi',
        'air_conditioning',
        'bed_linen',
        'cleaning',
        'private_bathroom',
        'canteen',
        'vending',
        'security',
        'gym',
        'sports_field',
        'bike_parking',
        'parking',
        'shuttle',
        'elevator'
    ])).max(20),
    admittedInstitutions: z.array(z.string().min(1).max(10)).max(50),
    callLinkUrl: z.union([
        z.url(),
        z.null()
    ]),
    contractSigningDays: z.union([
        z.int().gte(1).lte(90),
        z.null()
    ]),
    contractSigningInstructions: z.union([
        z.string().min(1).max(2000),
        z.null()
    ]),
    depositInstructions: z.union([
        z.string().min(1).max(2000),
        z.null()
    ]),
    iban: z.union([
        z.string().max(34),
        z.null()
    ]),
    bankAccountHolder: z.union([
        z.string().min(1).max(2000),
        z.null()
    ]),
    id: z.string(),
    slug: z.string(),
    roomCounts: zResidenceRoomCounts,
    dsuSingleRateCents: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    dsuDoubleRateCents: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    photos: z.array(zResidencePhoto),
    call: z.object({
        id: z.string(),
        academicYear: zAcademicYear,
        state: z.enum([
            'draft',
            'published',
            'open',
            'closed'
        ]),
        dataConfirmedAt: z.union([
            z.string(),
            z.null()
        ]),
        nextAcademicYear: z.union([
            z.string().regex(/^\d{4}\/\d{4}$/),
            z.null()
        ])
    }),
    issues: z.array(zResidenceValidationError),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput
});

export const zCallIntake = z.object({
    state: z.enum([
        'not_started',
        'open',
        'closed'
    ]),
    closesAt: z.union([
        z.string(),
        z.null()
    ]),
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    closeKind: z.nullable(z.enum(['declared', 'expired'])),
    closedBy: z.union([
        z.object({
            id: z.string(),
            name: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    directApplications: z.int().gte(-9007199254740991).lte(9007199254740991),
    flagsCloseAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zManagedCall = z.object({
    id: z.string(),
    academicYear: zAcademicYear,
    readOnly: z.boolean(),
    state: z.enum([
        'draft',
        'published',
        'open',
        'closed'
    ]),
    startAt: z.union([
        z.string(),
        z.null()
    ]),
    endDay: z.union([
        z.string(),
        z.null()
    ]),
    closeAt: z.union([
        z.string(),
        z.null()
    ]),
    canChangeDates: z.boolean(),
    rulesVersion: zCallRulesVersion,
    residence: zResidence,
    dataConfirmedAt: z.union([
        z.string(),
        z.null()
    ]),
    dataConfirmationVoidedAt: z.union([
        z.string(),
        z.null()
    ]),
    publication: z.array(zPublicationCheck),
    publishedAt: z.union([
        z.string(),
        z.null()
    ]),
    publicRankingUrl: z.union([
        z.url(),
        z.null()
    ]),
    paramsFingerprint: z.union([
        z.string(),
        z.null()
    ]),
    intake: zCallIntake,
    applications: z.object({
        phase: z.enum([
            'open',
            'remaining',
            'full',
            'stopped',
            'closed'
        ]),
        stoppedAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    previousYearBlock: z.union([
        z.object({
            academicYear: zAcademicYear,
            holds: z.enum(['applications', 'offers'])
        }),
        z.null()
    ])
});

export const zManagerHome = z.object({
    call: z.object({
        id: z.string(),
        state: z.enum([
            'draft',
            'published',
            'open',
            'closed'
        ]),
        startAt: z.union([
            z.string(),
            z.null()
        ]),
        endDay: z.union([
            z.string(),
            z.null()
        ]),
        closeAt: z.union([
            z.string(),
            z.null()
        ]),
        intake: zCallIntake
    }),
    counters: z.object({
        sending: zApplicationSendingCounters,
        valid: z.int().gte(-9007199254740991).lte(9007199254740991),
        superseded: z.int().gte(-9007199254740991).lte(9007199254740991),
        withdrawn: z.int().gte(-9007199254740991).lte(9007199254740991),
        openFlags: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        pendingVerifications: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        awaitingStudentNumber: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    tasks: z.array(z.object({
        type: z.enum([
            'confirm_data',
            'confirm_mailbox_test',
            'resolve_flags',
            'verifications_pending',
            'dsu_quota_below_threshold',
            'upload_direct_applications',
            'review_applications',
            'read_notices',
            'approve_ranking',
            'confirm_offer_expiries',
            'resend_bounced_offers',
            'send_offers_by_pec'
        ]),
        count: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        dueAt: z.union([
            z.string(),
            z.null()
        ])
    })),
    news: z.array(z.object({
        id: z.string(),
        kind: z.enum([
            'replacement',
            'withdrawal',
            'restored'
        ]),
        submissionId: z.string(),
        protocol: z.string(),
        createdAt: zInstantOutput
    })),
    dsuQuota: z.union([
        z.object({
            fundedBeds: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            threshold: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            dsuSeats: z.int().gte(-9007199254740991).lte(9007199254740991),
            gap: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            belowThreshold: z.boolean(),
            q30Seats: z.int().gte(-9007199254740991).lte(9007199254740991),
            covered: z.int().gte(-9007199254740991).lte(9007199254740991),
            inProgress: z.int().gte(-9007199254740991).lte(9007199254740991),
            uncovered: z.int().gte(-9007199254740991).lte(9007199254740991),
            unassigned: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ])
});

export const zDsuQuotaValues = z.object({
    fundedBeds: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    threshold: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    dsuSeats: z.int().gte(-9007199254740991).lte(9007199254740991),
    gap: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    belowThreshold: z.boolean(),
    q30Seats: z.int().gte(-9007199254740991).lte(9007199254740991),
    covered: z.int().gte(-9007199254740991).lte(9007199254740991),
    inProgress: z.int().gte(-9007199254740991).lte(9007199254740991),
    uncovered: z.int().gte(-9007199254740991).lte(9007199254740991),
    unassigned: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zWallTime = z.string();

export const zCallStartInPast = z.object({
    code: z.enum(['call_start_in_past']),
    message: z.string()
});

export const zCallEndBeforeStart = z.object({
    code: z.enum(['call_end_before_start']),
    message: z.string()
});

export const zCallMonitoringRow = z.object({
    residence: z.object({
        id: z.string(),
        name: z.string()
    }),
    call: z.object({
        academicYear: zAcademicYear,
        state: z.enum([
            'draft',
            'published',
            'open',
            'closed'
        ]),
        startAt: z.union([
            z.string(),
            z.null()
        ]),
        closeAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    intake: z.object({
        state: z.enum([
            'not_started',
            'open',
            'closed'
        ]),
        closesAt: z.union([
            z.string(),
            z.null()
        ]),
        closedAt: z.union([
            z.string(),
            z.null()
        ]),
        closeKind: z.nullable(z.enum(['declared', 'expired']))
    }),
    flags: z.object({
        open: z.int().gte(-9007199254740991).lte(9007199254740991),
        toVerify: z.int().gte(-9007199254740991).lte(9007199254740991),
        awaitingClarification: z.int().gte(-9007199254740991).lte(9007199254740991),
        clarificationReceived: z.int().gte(-9007199254740991).lte(9007199254740991),
        clarificationExpired: z.int().gte(-9007199254740991).lte(9007199254740991),
        closed: z.int().gte(-9007199254740991).lte(9007199254740991),
        closeAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    isCurrent: z.boolean(),
    applications: z.union([
        z.object({
            sent: z.int().gte(-9007199254740991).lte(9007199254740991),
            delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
            notDelivered: z.int().gte(-9007199254740991).lte(9007199254740991),
            acknowledged: z.int().gte(-9007199254740991).lte(9007199254740991),
            withProblem: z.int().gte(-9007199254740991).lte(9007199254740991),
            awaitingReview: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ]),
    ranking: z.union([
        z.object({
            state: z.enum([
                'control',
                'published_review',
                'final'
            ]),
            pageState: z.enum([
                'placeholder',
                'enabled',
                'disabled'
            ]),
            versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
            computedAt: zInstantOutput,
            fingerprint: z.string()
        }),
        z.null()
    ]),
    offers: z.union([
        z.object({
            launchedAt: zInstantOutput,
            waiting: z.int().gte(-9007199254740991).lte(9007199254740991),
            accepted: z.int().gte(-9007199254740991).lte(9007199254740991),
            overdue: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ]),
    dsuQuota: z.union([
        z.object({
            dsuSeats: z.int().gte(-9007199254740991).lte(9007199254740991),
            threshold: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            belowThreshold: z.boolean()
        }),
        z.null()
    ]),
    late: z.boolean(),
    lastReminder: z.union([
        z.object({
            at: zInstantOutput,
            by: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zEmailMessage = z.object({
    id: z.string(),
    template: z.string(),
    textVersionId: z.union([
        z.string(),
        z.null()
    ]),
    toAddress: z.string(),
    userId: z.union([
        z.string(),
        z.null()
    ]),
    backofficeUserId: z.union([
        z.string(),
        z.null()
    ]),
    state: z.enum([
        'queued',
        'sent',
        'delivered',
        'bounced',
        'complained',
        'failed'
    ]),
    bounceType: z.nullable(z.enum(['permanent', 'transient'])),
    lastEventAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zCursorPaginationMeta = z.object({
    total: z.number(),
    nextCursor: z.union([
        z.string(),
        z.null()
    ])
});

export const zEmailTextBlockSpec = z.object({
    key: z.string(),
    variables: z.array(z.string()),
    required: z.array(z.string()),
    multiline: z.boolean()
});

export const zEmailTextVersion = z.object({
    id: z.union([
        z.string(),
        z.null()
    ]),
    version: z.int().gte(-9007199254740991).lte(9007199254740991),
    createdAt: z.union([
        z.string(),
        z.null()
    ]),
    createdByName: z.union([
        z.string(),
        z.null()
    ])
});

export const zEmailTextLocale = z.object({
    locale: z.enum(['en', 'it']),
    current: zEmailTextVersion,
    blocks: z.record(z.string(), z.string()),
    history: z.array(zEmailTextVersion)
});

export const zEmailText = z.object({
    code: z.string(),
    audience: z.enum([
        'student',
        'manager',
        'admin'
    ]),
    template: z.string(),
    blocks: z.array(zEmailTextBlockSpec),
    locales: z.array(zEmailTextLocale)
});

export const zEmailTextIssue = z.object({
    block: z.string(),
    problem: z.enum([
        'empty',
        'missing_variable',
        'unknown_variable',
        'malformed_variable',
        'repeated_variable',
        'unknown_block'
    ]),
    variable: z.union([
        z.string(),
        z.null()
    ])
});

export const zEventLogFilters = z.object({
    residenceId: z.optional(z.string()),
    callId: z.optional(z.string()),
    actorId: z.optional(z.string()),
    action: z.optional(z.enum([
        'user.ban',
        'user.unban',
        'user.delete',
        'backoffice_user.invited',
        'backoffice_user.disabled',
        'backoffice_user.enabled',
        'backoffice_user.deleted',
        'backoffice_user.locked',
        'backoffice_user.signed_in',
        'backoffice_user.residence_linked',
        'backoffice_user.residence_unlinked',
        'residence.created',
        'dsu_rate.set',
        'residence.updated',
        'residence.funded_beds_corrected',
        'residence.photos_changed',
        'residence.location_changed',
        'residence.privacy_notice_changed',
        'residence.preview_link_created',
        'residence.institutions_migrated',
        'residence.correction_requested',
        'residence.correction_closed',
        'call.created',
        'call.data_confirmed',
        'call.data_confirmation_voided',
        'call.published',
        'call.dates_set',
        'call.funded_beds_corrected',
        'call.contract_info_corrected',
        'call.opened',
        'call.closed',
        'call.intake_closed',
        'call.applications_stopped',
        'call.applications_resumed',
        'call.reminder_sent',
        'pec.queued',
        'pec.sent',
        'pec.accepted',
        'pec.delivered',
        'pec.delivery_failed',
        'pec.retry_scheduled',
        'pec.undeliverable',
        'pec.retry_cancelled',
        'pec.retry_requested',
        'pec.acceptance_missing',
        'pec.receipt_noted',
        'sending_anomaly.opened',
        'sending_anomaly.closed',
        'sending_anomaly.manager_notified',
        'pec.receipt_matched_manually',
        'session.created',
        'session.removed',
        'session.opened',
        'session.closed',
        'personal_data.viewed',
        'pec_test.sent',
        'pec_test.confirmed',
        'pec_test.failed_attempt',
        'pec_test.voided',
        'mailbox_test.sent',
        'mailbox_test.confirmed',
        'mailbox_test.failed_attempt',
        'mailbox_test.voided',
        'email_text.saved',
        'geo.municipalities_imported',
        'geo.institutions_imported',
        'application.draft_created',
        'application.draft_updated',
        'application.warning_raised',
        'application.warning_cleared',
        'application.warnings_confirmed',
        'application.declarations_changed',
        'application.residence_added',
        'application.residence_removed',
        'application.document_uploaded',
        'application.document_replaced',
        'application.transmitted',
        'application.acknowledged',
        'application.withdrawal_transmitted',
        'manager_notice.created',
        'application.problem_reported',
        'application.annex_downloaded',
        'application.annex_uploaded',
        'application.annex_replaced',
        'application.document_removed',
        'application.signed',
        'application.submitted',
        'application.superseded',
        'application.possible_duplicate',
        'application.withdrawn',
        'application.withdrawal_undone',
        'application.sign_failed',
        'application.effective_time_set',
        'application.receipt_resent',
        'application.direct_registered',
        'application.direct_corrected',
        'application.direct_pec_reply_sent',
        'application.direct_claimed',
        'student.email_changed',
        'support.access_code_resent',
        'support.request_opened',
        'support.request_closed',
        'privacy_notice.acknowledged',
        'student.tax_code_released',
        'student.duplicate_suspected',
        'flag.created',
        'flag.resolved',
        'flag.clarification_requested',
        'flag.withdrawn_by_correction',
        'flag.reopened_by_correction',
        'flag.clarification_answered',
        'flag.clarification_expired',
        'ranking.computed',
        'ranking.version_created',
        'ranking.version_published',
        'ranking.approved',
        'ranking.page_enabled',
        'ranking.page_disabled',
        'ranking.finalized',
        'ranking.report_created',
        'ranking.report_closed',
        'ranking.disability_priority_revoked',
        'ranking.disability_priority_restored',
        'offer.launched',
        'offer.scheduled',
        'offer.sent',
        'offer.reminder_sent',
        'offer.reply_received',
        'offer.accepted',
        'offer.declined',
        'offer.expiry_proposed',
        'offer.expired',
        'offer.bounced',
        'offer.resent',
        'offer.withdrawn',
        'offer.seat_origin_changed',
        'offer.pec_send_recorded',
        'offer.contact_noted',
        'offer.expiry_confirm_overdue',
        'verification.created',
        'verification.item_checked',
        'verification.difference_noted',
        'verification.excluded',
        'verification.exclusion_corrected',
        'verification.student_number_requested',
        'verification.student_number_recorded',
        'room.proposed',
        'room.reproposed',
        'room.checked_in',
        'dsu_quota.seat_uncovered',
        'dsu_quota.below_threshold',
        'dsu_quota.back_in_line',
        'dsu_quota.reconciled',
        'dsu_quota.report_exported',
        'dsu_quota.ministry_answer_recorded',
        'dsu_quota.offers_unlocked',
        'verification.compliant',
        'assignment.forfeited'
    ])),
    from: z.optional(zInstant),
    to: z.optional(zInstant)
});

export const zEventLogItem = z.object({
    id: z.string(),
    occurredAt: zInstantOutput,
    actorType: z.enum([
        'student',
        'backoffice',
        'system'
    ]),
    actorId: z.union([
        z.string(),
        z.null()
    ]),
    actorName: z.string(),
    actorRole: z.string(),
    action: z.enum([
        'user.ban',
        'user.unban',
        'user.delete',
        'backoffice_user.invited',
        'backoffice_user.disabled',
        'backoffice_user.enabled',
        'backoffice_user.deleted',
        'backoffice_user.locked',
        'backoffice_user.signed_in',
        'backoffice_user.residence_linked',
        'backoffice_user.residence_unlinked',
        'residence.created',
        'dsu_rate.set',
        'residence.updated',
        'residence.funded_beds_corrected',
        'residence.photos_changed',
        'residence.location_changed',
        'residence.privacy_notice_changed',
        'residence.preview_link_created',
        'residence.institutions_migrated',
        'residence.correction_requested',
        'residence.correction_closed',
        'call.created',
        'call.data_confirmed',
        'call.data_confirmation_voided',
        'call.published',
        'call.dates_set',
        'call.funded_beds_corrected',
        'call.contract_info_corrected',
        'call.opened',
        'call.closed',
        'call.intake_closed',
        'call.applications_stopped',
        'call.applications_resumed',
        'call.reminder_sent',
        'pec.queued',
        'pec.sent',
        'pec.accepted',
        'pec.delivered',
        'pec.delivery_failed',
        'pec.retry_scheduled',
        'pec.undeliverable',
        'pec.retry_cancelled',
        'pec.retry_requested',
        'pec.acceptance_missing',
        'pec.receipt_noted',
        'sending_anomaly.opened',
        'sending_anomaly.closed',
        'sending_anomaly.manager_notified',
        'pec.receipt_matched_manually',
        'session.created',
        'session.removed',
        'session.opened',
        'session.closed',
        'personal_data.viewed',
        'pec_test.sent',
        'pec_test.confirmed',
        'pec_test.failed_attempt',
        'pec_test.voided',
        'mailbox_test.sent',
        'mailbox_test.confirmed',
        'mailbox_test.failed_attempt',
        'mailbox_test.voided',
        'email_text.saved',
        'geo.municipalities_imported',
        'geo.institutions_imported',
        'application.draft_created',
        'application.draft_updated',
        'application.warning_raised',
        'application.warning_cleared',
        'application.warnings_confirmed',
        'application.declarations_changed',
        'application.residence_added',
        'application.residence_removed',
        'application.document_uploaded',
        'application.document_replaced',
        'application.transmitted',
        'application.acknowledged',
        'application.withdrawal_transmitted',
        'manager_notice.created',
        'application.problem_reported',
        'application.annex_downloaded',
        'application.annex_uploaded',
        'application.annex_replaced',
        'application.document_removed',
        'application.signed',
        'application.submitted',
        'application.superseded',
        'application.possible_duplicate',
        'application.withdrawn',
        'application.withdrawal_undone',
        'application.sign_failed',
        'application.effective_time_set',
        'application.receipt_resent',
        'application.direct_registered',
        'application.direct_corrected',
        'application.direct_pec_reply_sent',
        'application.direct_claimed',
        'student.email_changed',
        'support.access_code_resent',
        'support.request_opened',
        'support.request_closed',
        'privacy_notice.acknowledged',
        'student.tax_code_released',
        'student.duplicate_suspected',
        'flag.created',
        'flag.resolved',
        'flag.clarification_requested',
        'flag.withdrawn_by_correction',
        'flag.reopened_by_correction',
        'flag.clarification_answered',
        'flag.clarification_expired',
        'ranking.computed',
        'ranking.version_created',
        'ranking.version_published',
        'ranking.approved',
        'ranking.page_enabled',
        'ranking.page_disabled',
        'ranking.finalized',
        'ranking.report_created',
        'ranking.report_closed',
        'ranking.disability_priority_revoked',
        'ranking.disability_priority_restored',
        'offer.launched',
        'offer.scheduled',
        'offer.sent',
        'offer.reminder_sent',
        'offer.reply_received',
        'offer.accepted',
        'offer.declined',
        'offer.expiry_proposed',
        'offer.expired',
        'offer.bounced',
        'offer.resent',
        'offer.withdrawn',
        'offer.seat_origin_changed',
        'offer.pec_send_recorded',
        'offer.contact_noted',
        'offer.expiry_confirm_overdue',
        'verification.created',
        'verification.item_checked',
        'verification.difference_noted',
        'verification.excluded',
        'verification.exclusion_corrected',
        'verification.student_number_requested',
        'verification.student_number_recorded',
        'room.proposed',
        'room.reproposed',
        'room.checked_in',
        'dsu_quota.seat_uncovered',
        'dsu_quota.below_threshold',
        'dsu_quota.back_in_line',
        'dsu_quota.reconciled',
        'dsu_quota.report_exported',
        'dsu_quota.ministry_answer_recorded',
        'dsu_quota.offers_unlocked',
        'verification.compliant',
        'assignment.forfeited'
    ]),
    entityType: z.enum([
        'user',
        'backoffice_user',
        'residence',
        'residence_correction_request',
        'call',
        'pec_message',
        'sending_anomaly',
        'support_request',
        'session',
        'backoffice_route',
        'pec_test',
        'mailbox_test',
        'email_text_version',
        'dsu_rate',
        'dataset',
        'application',
        'application_submission',
        'requirement_flag',
        'manager_notice',
        'ranking',
        'ranking_report',
        'offer',
        'verification',
        'assignment_forfeit',
        'room_assignment'
    ]),
    entityId: z.string(),
    residenceId: z.union([
        z.string(),
        z.null()
    ]),
    callId: z.union([
        z.string(),
        z.null()
    ]),
    reason: z.union([
        z.string(),
        z.null()
    ]),
    data: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])
});

export const zInstitutionSite = z.object({
    code: z.string(),
    municipalityIstatCode: z.string(),
    municipalityName: z.string(),
    provinceCode: z.string(),
    studySite: z.enum([
        'rome',
        'cassino',
        'viterbo',
        'other'
    ])
});

export const zInstitution = z.object({
    code: z.string(),
    name: z.string(),
    operationalName: z.string(),
    ownership: z.enum(['state', 'private']),
    isOnline: z.boolean(),
    sites: z.array(zInstitutionSite)
});

export const zOfferLaunchRow = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    category: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    quota: z.enum(['q30', 'q70']),
    channel: z.enum(['email', 'residence_pec'])
});

export const zOfferLaunchPreview = z.object({
    canLaunch: z.boolean(),
    block: z.nullable(z.enum([
        'ranking_not_final',
        'already_launched',
        'contract_info_missing',
        'recalculation_pending',
        'ministry_answer_missing'
    ])),
    reviewWindowEndsAt: z.union([
        z.string(),
        z.null()
    ]),
    ministryWait: z.union([
        z.object({
            uncoveredSeats: z.int().gt(0).lte(9007199254740991),
            waitingInQ70: z.int().gt(0).lte(9007199254740991)
        }),
        z.null()
    ]),
    launchedAt: z.union([
        z.string(),
        z.null()
    ]),
    versionNumber: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    firstSendAt: zInstantOutput,
    assigned: z.array(zOfferLaunchRow),
    text: z.object({
        subject: z.string(),
        body: z.string()
    })
});

export const zOfferRow = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    id: z.string(),
    category: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    quota: z.enum(['q30', 'q70']),
    origin: z.enum(['initial', 'scrolling']),
    channel: z.enum(['email', 'residence_pec']),
    state: z.enum([
        'scheduled',
        'sent',
        'bounced',
        'expiry_proposed',
        'accepted',
        'declined',
        'expired',
        'withdrawn',
        'revoked',
        'renounced_after_acceptance'
    ]),
    sendAfter: zInstantOutput,
    sentAt: z.union([
        z.string(),
        z.null()
    ]),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    confirmDueAt: z.union([
        z.string(),
        z.null()
    ]),
    decidedAt: z.union([
        z.string(),
        z.null()
    ]),
    lastDeliveryFailed: z.boolean(),
    contactNote: z.union([
        z.string(),
        z.null()
    ]),
    lastReply: z.union([
        z.object({
            receivedAt: zInstantOutput,
            channel: z.enum(['button', 'manager_record']),
            decision: z.enum(['accept', 'decline']),
            state: z.enum([
                'applied',
                'late',
                'ignored'
            ])
        }),
        z.null()
    ])
});

export const zOfferList = z.object({
    launchedAt: z.union([
        z.string(),
        z.null()
    ]),
    versionNumber: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    counts: z.record(z.string(), z.int().gte(0).lte(9007199254740991)),
    unfilledSeats: z.object({
        q30: z.int().gte(0).lte(9007199254740991),
        q70: z.int().gte(0).lte(9007199254740991)
    }),
    overbooked: z.object({
        q30: z.int().gte(0).lte(9007199254740991),
        q70: z.int().gte(0).lte(9007199254740991)
    }),
    offers: z.array(zOfferRow)
});

export const zMyOffer = z.object({
    id: z.string(),
    submissionId: z.string(),
    residenceName: z.string(),
    protocol: z.string(),
    quota: z.enum(['q30', 'q70']),
    state: z.enum([
        'scheduled',
        'sent',
        'bounced',
        'expiry_proposed',
        'accepted',
        'declined',
        'expired',
        'withdrawn',
        'revoked',
        'renounced_after_acceptance'
    ]),
    sentAt: z.union([
        z.string(),
        z.null()
    ]),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    deadline: z.union([
        z.string(),
        z.null()
    ]),
    decidedAt: z.union([
        z.string(),
        z.null()
    ]),
    decidedVia: z.nullable(z.enum(['button', 'manager_record'])),
    withdrawnReason: z.nullable(z.enum(['accepted_elsewhere', 'disability_priority_revoked']))
});

export const zMyOfferDetail = z.object({
    id: z.string(),
    submissionId: z.string(),
    residenceName: z.string(),
    protocol: z.string(),
    quota: z.enum(['q30', 'q70']),
    state: z.enum([
        'scheduled',
        'sent',
        'bounced',
        'expiry_proposed',
        'accepted',
        'declined',
        'expired',
        'withdrawn',
        'revoked',
        'renounced_after_acceptance'
    ]),
    sentAt: z.union([
        z.string(),
        z.null()
    ]),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    deadline: z.union([
        z.string(),
        z.null()
    ]),
    decidedAt: z.union([
        z.string(),
        z.null()
    ]),
    decidedVia: z.nullable(z.enum(['button', 'manager_record'])),
    withdrawnReason: z.nullable(z.enum(['accepted_elsewhere', 'disability_priority_revoked'])),
    text: z.union([
        z.string(),
        z.null()
    ]),
    terms: z.object({
        rates: z.array(z.object({
            roomType: z.enum(['single', 'double']),
            cents: z.union([
                z.number(),
                z.null()
            ])
        })),
        roomPreference: z.enum([
            'single',
            'double',
            'none'
        ]),
        signing: z.union([
            z.string(),
            z.null()
        ]),
        duration: z.string(),
        deposit: z.string(),
        payment: z.string(),
        iban: z.union([
            z.string(),
            z.null()
        ]),
        accountHolder: z.union([
            z.string(),
            z.null()
        ])
    }),
    willWithdraw: z.array(z.object({
        residenceName: z.string(),
        protocol: z.string(),
        hasOpenOffer: z.boolean()
    }))
});

export const zOfferExpiryRow = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    id: z.string(),
    quota: z.enum(['q30', 'q70']),
    channel: z.enum(['email', 'residence_pec']),
    sentAt: zInstantOutput,
    expiresAt: zInstantOutput,
    confirmDueAt: z.union([
        z.string(),
        z.null()
    ]),
    lastDeliveryFailed: z.boolean(),
    lateReplies: z.array(z.object({
        receivedAt: zInstantOutput,
        decision: z.enum(['accept', 'decline'])
    }))
});

export const zOfferPecText = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    recipient: z.string(),
    subject: z.string(),
    body: z.string(),
    deadline: z.string()
});

export const zPublicRanking = z.union([
    z.object({
        phase: z.enum(['placeholder']),
        residenceName: z.string(),
        startAt: zInstantOutput,
        closeAt: zInstantOutput
    }),
    z.object({
        phase: z.enum(['disabled']),
        residenceName: z.string(),
        startAt: zInstantOutput,
        closeAt: zInstantOutput,
        disabledAt: zInstantOutput
    }),
    z.object({
        phase: z.enum(['published_review', 'final']),
        residence: z.object({
            name: z.string(),
            startAt: zInstantOutput,
            closeAt: zInstantOutput
        }),
        status: z.object({
            windowEndsAt: z.union([
                z.string(),
                z.null()
            ]),
            versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
            publishedAt: zInstantOutput
        }),
        lists: z.object({
            freshers: z.object({
                seats: z.int().gte(0).lte(9007199254740991),
                rows: z.array(z.object({
                    position: z.int().gt(0).lte(9007199254740991),
                    protocol: z.string(),
                    score: z.union([
                        z.int().gte(-9007199254740991).lte(9007199254740991),
                        z.null()
                    ]),
                    outcome: z.enum([
                        'assigned',
                        'no_seat',
                        'withdrawn',
                        'forfeited'
                    ])
                }))
            }),
            later_years: z.object({
                seats: z.int().gte(0).lte(9007199254740991),
                rows: z.array(z.object({
                    position: z.int().gt(0).lte(9007199254740991),
                    protocol: z.string(),
                    score: z.union([
                        z.int().gte(-9007199254740991).lte(9007199254740991),
                        z.null()
                    ]),
                    outcome: z.enum([
                        'assigned',
                        'no_seat',
                        'withdrawn',
                        'forfeited'
                    ])
                }))
            }),
            doctoral: z.object({
                seats: z.int().gte(0).lte(9007199254740991),
                rows: z.array(z.object({
                    position: z.int().gt(0).lte(9007199254740991),
                    protocol: z.string(),
                    score: z.union([
                        z.int().gte(-9007199254740991).lte(9007199254740991),
                        z.null()
                    ]),
                    outcome: z.enum([
                        'assigned',
                        'no_seat',
                        'withdrawn',
                        'forfeited'
                    ])
                }))
            })
        }),
        validApplications: z.int().gte(0).lte(9007199254740991),
        fingerprint: z.string(),
        versions: z.array(z.object({
            number: z.int().gte(-9007199254740991).lte(9007199254740991),
            publishedAt: zInstantOutput,
            reason: z.enum([
                'first_calculation',
                'flag_resolved',
                'transcription_corrected',
                'scrolling',
                'disability_priority_revoked',
                'disability_priority_restored',
                'withdrawal_undone',
                'late_application',
                'ministry_authorization',
                'assignment_forfeited',
                'forfeit_annulled'
            ]),
            isCurrent: z.boolean()
        }))
    })
]);

export const zPublicResidenceSitePlace = z.object({
    name: z.string(),
    address: z.string(),
    city: z.string(),
    location: z.union([
        z.object({
            latitude: z.number(),
            longitude: z.number()
        }),
        z.null()
    ])
});

export const zPublicResidenceLocation = z.object({
    latitude: z.number(),
    longitude: z.number()
});

export const zPublicCall = z.object({
    academicYear: zAcademicYear,
    state: z.enum([
        'published',
        'open',
        'closed'
    ]),
    startAt: zInstantOutput,
    closeAt: zInstantOutput,
    endDay: zFloatingDateOutput
});

export const zPublicResidenceListItem = z.object({
    slug: z.string(),
    name: z.string(),
    city: z.string(),
    sites: z.array(zPublicResidenceSitePlace).min(1),
    cover: z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ]),
    minRateCents: z.object({
        q30: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        q70: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    photos: z.array(zImagePayload).max(5),
    roomTypes: z.array(z.enum(['single', 'double'])),
    services: z.array(z.enum([
        'study_room',
        'library',
        'common_kitchen',
        'common_room',
        'laundry',
        'garden',
        'wifi',
        'air_conditioning',
        'bed_linen',
        'cleaning',
        'private_bathroom',
        'canteen',
        'vending',
        'security',
        'gym',
        'sports_field',
        'bike_parking',
        'parking',
        'shuttle',
        'elevator'
    ])),
    hasEquippedSeats: z.boolean(),
    seats: z.object({
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    remainingSeats: z.object({
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    call: zPublicCall,
    intake: z.enum([
        'open',
        'remaining',
        'full',
        'stopped',
        'closed'
    ])
});

export const zPublicResidenceList = z.object({
    residences: z.array(zPublicResidenceListItem),
    cities: z.array(z.string()),
    services: z.array(z.enum([
        'study_room',
        'library',
        'common_kitchen',
        'common_room',
        'laundry',
        'garden',
        'wifi',
        'air_conditioning',
        'bed_linen',
        'cleaning',
        'private_bathroom',
        'canteen',
        'vending',
        'security',
        'gym',
        'sports_field',
        'bike_parking',
        'parking',
        'shuttle',
        'elevator'
    ])),
    hasEquipped: z.boolean(),
    pnrrNotice: z.string()
});

export const zPublicResidenceSite = z.object({
    name: z.string(),
    address: z.string(),
    city: z.string(),
    location: z.union([
        z.object({
            latitude: z.number(),
            longitude: z.number()
        }),
        z.null()
    ]),
    typology: z.union([
        z.string(),
        z.null()
    ]),
    singleBeds: z.int().gte(-9007199254740991).lte(9007199254740991),
    doubleBeds: z.int().gte(-9007199254740991).lte(9007199254740991),
    bathroomsCount: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    bathroomsDescription: z.union([
        z.string(),
        z.null()
    ]),
    kitchensCount: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    kitchensDescription: z.union([
        z.string(),
        z.null()
    ]),
    otherServicesDescription: z.union([
        z.string(),
        z.null()
    ]),
    equippedSingleBeds: z.int().gte(-9007199254740991).lte(9007199254740991),
    equippedDoubleBeds: z.int().gte(-9007199254740991).lte(9007199254740991),
    equippedBathroomsDescription: z.union([
        z.string(),
        z.null()
    ]),
    equippedKitchensDescription: z.union([
        z.string(),
        z.null()
    ]),
    equippedOtherServicesDescription: z.union([
        z.string(),
        z.null()
    ]),
    distances: z.array(z.object({
        institutionCode: z.string(),
        institutionName: z.string(),
        municipalityName: z.string(),
        km: z.number()
    }))
});

export const zPublicResidenceCall = z.object({
    academicYear: zAcademicYear,
    state: z.enum([
        'draft',
        'published',
        'open',
        'closed'
    ]),
    startAt: z.union([
        z.string(),
        z.null()
    ]),
    closeAt: z.union([
        z.string(),
        z.null()
    ]),
    endDay: z.union([
        z.string(),
        z.null()
    ])
});

export const zPublicResidence = z.object({
    slug: z.string(),
    name: z.string(),
    city: z.string(),
    sites: z.array(zPublicResidenceSite).min(1),
    photos: z.array(z.object({
        id: z.string(),
        image: z.union([
            z.object({
                url: z.string(),
                blurhash: z.union([
                    z.string(),
                    z.null()
                ]),
                width: z.union([
                    z.int().gte(-9007199254740991).lte(9007199254740991),
                    z.null()
                ]),
                height: z.union([
                    z.int().gte(-9007199254740991).lte(9007199254740991),
                    z.null()
                ]),
                variants: z.union([
                    z.object({
                        original: z.optional(z.string()),
                        thumbnail: z.optional(z.string()),
                        small: z.optional(z.string()),
                        medium: z.optional(z.string()),
                        large: z.optional(z.string())
                    }),
                    z.null()
                ])
            }),
            z.null()
        ])
    })),
    services: z.array(z.enum([
        'study_room',
        'library',
        'common_kitchen',
        'common_room',
        'laundry',
        'garden',
        'wifi',
        'air_conditioning',
        'bed_linen',
        'cleaning',
        'private_bathroom',
        'canteen',
        'vending',
        'security',
        'gym',
        'sports_field',
        'bike_parking',
        'parking',
        'shuttle',
        'elevator'
    ])),
    rates: z.object({
        q30: z.object({
            single: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            double: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ])
        }),
        q70: z.object({
            single: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            double: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ])
        })
    }),
    seats: z.object({
        q30: z.object({
            single: z.int().gte(-9007199254740991).lte(9007199254740991),
            double: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        q70: z.object({
            single: z.int().gte(-9007199254740991).lte(9007199254740991),
            double: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }),
    remainingSeats: z.object({
        q30: z.int().gte(-9007199254740991).lte(9007199254740991),
        q70: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    freeSeats: z.object({
        q30: z.object({
            single: z.int().gte(-9007199254740991).lte(9007199254740991),
            double: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        q70: z.object({
            single: z.int().gte(-9007199254740991).lte(9007199254740991),
            double: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }),
    hasEquippedSeats: z.boolean(),
    admittedInstitutions: z.array(z.object({
        code: z.string(),
        name: z.string()
    })),
    preview: z.boolean(),
    call: zPublicResidenceCall,
    intake: z.enum([
        'open',
        'remaining',
        'full',
        'stopped',
        'closed'
    ]),
    callLinkUrl: z.union([
        z.string(),
        z.null()
    ]),
    callText: z.union([
        z.array(z.object({
            kind: z.enum([
                'title',
                'subtitle',
                'heading',
                'paragraph'
            ]),
            text: z.string()
        })),
        z.null()
    ]),
    hasCallDocument: z.boolean(),
    pnrrNotice: z.string(),
    ranking: z.union([
        z.object({
            path: z.string(),
            phase: z.enum(['published_review', 'final'])
        }),
        z.null()
    ])
});

export const zRankingRules = z.object({
    freshersShare: z.object({
        percent: z.int().gte(-9007199254740991).lte(9007199254740991),
        rounding: z.enum(['up'])
    }),
    weights: z.object({
        freshers: z.object({
            credits: z.int().gte(-9007199254740991).lte(9007199254740991),
            grade: z.int().gte(-9007199254740991).lte(9007199254740991),
            income: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        laterYears: z.object({
            credits: z.int().gte(-9007199254740991).lte(9007199254740991),
            grade: z.int().gte(-9007199254740991).lte(9007199254740991),
            income: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        doctoral: z.object({
            credits: z.int().gte(-9007199254740991).lte(9007199254740991),
            grade: z.int().gte(-9007199254740991).lte(9007199254740991),
            income: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }),
    decimals: z.int().gte(-9007199254740991).lte(9007199254740991),
    iseeuLimitCents: z.int().gte(-9007199254740991).lte(9007199254740991),
    grade: z.object({
        min: z.number(),
        max: z.number()
    }),
    ties: z.object({
        freshers: z.array(z.enum([
            'iseeu_asc',
            'age_asc',
            'credits_desc',
            'submitted_at_asc',
            'protocol_asc'
        ])),
        laterYears: z.array(z.enum([
            'iseeu_asc',
            'age_asc',
            'credits_desc',
            'submitted_at_asc',
            'protocol_asc'
        ])),
        doctoral: z.array(z.enum([
            'iseeu_asc',
            'age_asc',
            'credits_desc',
            'submitted_at_asc',
            'protocol_asc'
        ])),
        betweenLists: z.array(z.enum([
            'iseeu_asc',
            'age_asc',
            'credits_desc',
            'submitted_at_asc',
            'protocol_asc'
        ]))
    }),
    creditsTable: z.array(z.object({
        courseType: z.enum([
            'bachelor',
            'master',
            'single_cycle',
            'phd',
            'specialization'
        ]),
        enrollmentYear: z.int().gte(-9007199254740991).lte(9007199254740991),
        extraSemester: z.boolean(),
        minCredits: z.int().gte(-9007199254740991).lte(9007199254740991),
        maxCredits: z.int().gte(-9007199254740991).lte(9007199254740991)
    }))
});

export const zPublicApplicationRules = z.object({
    version: z.int().gte(-9007199254740991).lte(9007199254740991),
    otherVersionOpen: z.boolean(),
    ranking: zRankingRules,
    callCloseTime: z.object({
        value: z.string(),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ])
    }),
    manualIntakeDays: z.object({
        days: z.int().gt(0).lte(9007199254740991),
        kind: z.enum(['business', 'calendar']),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ])
    }),
    offerAcceptanceDays: z.object({
        days: z.int().gt(0).lte(9007199254740991),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ])
    }),
    reviewWindowHours: z.object({
        hours: z.int().gt(0).lte(9007199254740991),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ])
    }),
    transmission: z.object({
        subject: z.string(),
        text: z.string(),
        status: z.enum([
            'fissato',
            'da_compilare',
            'da_decidere',
            'da_verificare'
        ])
    }),
    pnrrNotice: z.string()
});

export const zRankingControlRow = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    position: z.int().gt(0).lte(9007199254740991),
    score: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    category: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    origin: z.enum(['platform', 'direct_pec']),
    outcome: z.enum([
        'assigned',
        'no_seat',
        'withdrawn',
        'forfeited'
    ]),
    quota: z.nullable(z.enum(['q30', 'q70'])),
    seatOrigin: z.nullable(z.enum([
        'ranking_order',
        'equipped_priority',
        'other_list',
        'ministry_authorization'
    ])),
    criterion: z.object({
        key: z.nullable(z.enum([
            'iseeu_asc',
            'age_asc',
            'credits_desc',
            'submitted_at_asc',
            'protocol_asc'
        ])),
        value: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    declaredDataUsed: z.boolean(),
    late: z.boolean(),
    disabilityPriorityRevoked: z.boolean()
});

export const zRankingControlNotAdmitted = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    category: z.nullable(z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ])),
    q30: z.object({
        status: z.enum([
            'admitted',
            'not_admitted',
            'pending'
        ]),
        reason: z.union([
            z.string(),
            z.null()
        ]),
        cause: z.union([
            z.string(),
            z.null()
        ])
    }),
    q70: z.object({
        status: z.enum([
            'admitted',
            'not_admitted',
            'pending'
        ]),
        reason: z.union([
            z.string(),
            z.null()
        ]),
        cause: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zRankingControlExcluded = z.object({
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    standingProtocol: z.string()
});

export const zRankingControlPage = z.union([
    z.object({
        list: z.enum([
            'freshers',
            'later_years',
            'doctoral',
            'q70',
            'q70_dsu_seat'
        ]),
        rows: z.array(zRankingControlRow)
    }),
    z.object({
        list: z.enum(['not_admitted']),
        rows: z.array(zRankingControlNotAdmitted)
    }),
    z.object({
        list: z.enum(['excluded']),
        rows: z.array(zRankingControlExcluded)
    })
]);

export const zRankingControl = z.object({
    ranking: z.union([
        z.object({
            id: z.string(),
            state: z.enum([
                'control',
                'published_review',
                'final'
            ]),
            pageState: z.enum([
                'placeholder',
                'enabled',
                'disabled'
            ]),
            approvedAt: z.union([
                z.string(),
                z.null()
            ]),
            publishedAt: z.union([
                z.string(),
                z.null()
            ]),
            reviewWindowEndsAt: z.union([
                z.string(),
                z.null()
            ]),
            finalAt: z.union([
                z.string(),
                z.null()
            ]),
            disabledAt: z.union([
                z.string(),
                z.null()
            ]),
            disableReason: z.union([
                z.string(),
                z.null()
            ]),
            version: z.object({
                number: z.int().gte(-9007199254740991).lte(9007199254740991),
                reason: z.enum([
                    'first_calculation',
                    'flag_resolved',
                    'transcription_corrected',
                    'scrolling',
                    'disability_priority_revoked',
                    'disability_priority_restored',
                    'withdrawal_undone',
                    'late_application',
                    'ministry_authorization',
                    'assignment_forfeited',
                    'forfeit_annulled'
                ]),
                computedAt: zInstantOutput,
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                validApplications: z.int().gte(0).lte(9007199254740991),
                outcomeFingerprint: z.string(),
                rulesVersionId: z.int().gte(-9007199254740991).lte(9007199254740991),
                seats: z.object({
                    q30: z.int().gte(0).lte(9007199254740991),
                    q70: z.int().gte(0).lte(9007199254740991)
                }),
                unfilledSeats: z.object({
                    q30: z.int().gte(0).lte(9007199254740991),
                    q70: z.int().gte(0).lte(9007199254740991)
                })
            })
        }),
        z.null()
    ]),
    seats: z.object({
        freshers: z.int().gte(0).lte(9007199254740991),
        later_years: z.int().gte(0).lte(9007199254740991),
        doctoral: z.int().gte(0).lte(9007199254740991),
        q70: z.int().gte(0).lte(9007199254740991)
    }),
    totals: z.record(z.string(), z.int().gte(0).lte(9007199254740991)),
    page: zRankingControlPage,
    versions: z.array(z.object({
        number: z.int().gte(-9007199254740991).lte(9007199254740991),
        reason: z.enum([
            'first_calculation',
            'flag_resolved',
            'transcription_corrected',
            'scrolling',
            'disability_priority_revoked',
            'disability_priority_restored',
            'withdrawal_undone',
            'late_application',
            'ministry_authorization',
            'assignment_forfeited',
            'forfeit_annulled'
        ]),
        computedAt: zInstantOutput,
        publishedAt: z.union([
            z.string(),
            z.null()
        ])
    })),
    conditions: z.array(z.object({
        code: z.enum([
            'call_closed',
            'intake_closed',
            'applications_reviewed',
            'flags_closed_or_expired',
            'calculation_done',
            'no_pending_recalculation'
        ]),
        met: z.boolean(),
        detail: z.union([
            z.object({
                openFlags: z.int().gte(0).lte(9007199254740991),
                flagsCloseAt: z.union([
                    z.string(),
                    z.null()
                ]),
                termMissing: z.boolean()
            }),
            z.object({
                awaitingReview: z.int().gte(0).lte(9007199254740991)
            }),
            z.object({
                pendingSince: z.union([
                    z.string(),
                    z.null()
                ]),
                failing: z.boolean()
            }),
            z.null()
        ])
    })),
    canApprove: z.boolean(),
    openReports: z.int().gte(0).lte(9007199254740991),
    publicPath: z.union([
        z.string(),
        z.null()
    ])
});

export const zStudentRanking = z.union([
    z.object({
        phase: z.enum(['not_published', 'disabled'])
    }),
    z.object({
        phase: z.enum(['published_review', 'final']),
        versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
        publishedAt: zInstantOutput,
        windowEndsAt: z.union([
            z.string(),
            z.null()
        ]),
        outcome: z.enum([
            'assigned',
            'no_seat',
            'not_admitted',
            'excluded',
            'withdrawn',
            'forfeited',
            'not_in_ranking'
        ]),
        category: z.nullable(z.enum([
            'first_year',
            'later_years',
            'doctoral_and_specialization'
        ])),
        late: z.boolean(),
        list: z.nullable(z.enum([
            'freshers',
            'later_years',
            'doctoral'
        ])),
        listPosition: z.union([
            z.int().gt(0).lte(9007199254740991),
            z.null()
        ]),
        q70Position: z.union([
            z.int().gt(0).lte(9007199254740991),
            z.null()
        ]),
        listSize: z.int().gte(0).lte(9007199254740991),
        q70Size: z.int().gte(0).lte(9007199254740991),
        seats: z.object({
            q30: z.int().gte(0).lte(9007199254740991),
            q70: z.int().gte(0).lte(9007199254740991)
        }),
        quota: z.nullable(z.enum(['q30', 'q70'])),
        seatOrigin: z.nullable(z.enum([
            'ranking_order',
            'equipped_priority',
            'other_list',
            'ministry_authorization'
        ])),
        score: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        lastAssignedScore: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        admission: z.union([
            z.object({
                q30: z.object({
                    status: z.enum([
                        'admitted',
                        'not_admitted',
                        'pending'
                    ]),
                    reason: z.union([
                        z.string(),
                        z.null()
                    ]),
                    cause: z.union([
                        z.string(),
                        z.null()
                    ]),
                    causeText: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                q70: z.object({
                    status: z.enum([
                        'admitted',
                        'not_admitted',
                        'pending'
                    ]),
                    reason: z.union([
                        z.string(),
                        z.null()
                    ]),
                    cause: z.union([
                        z.string(),
                        z.null()
                    ]),
                    causeText: z.union([
                        z.string(),
                        z.null()
                    ])
                })
            }),
            z.null()
        ]),
        rows: z.array(z.object({
            position: z.int().gt(0).lte(9007199254740991),
            protocol: z.string(),
            score: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            outcome: z.enum([
                'assigned',
                'no_seat',
                'withdrawn',
                'forfeited'
            ]),
            quota: z.optional(z.enum(['q30', 'q70'])),
            isMine: z.boolean()
        }))
    })
]);

export const zRankingProvisional = z.object({
    computedAt: zInstantOutput,
    seats: z.object({
        freshers: z.int().gte(0).lte(9007199254740991),
        later_years: z.int().gte(0).lte(9007199254740991),
        doctoral: z.int().gte(0).lte(9007199254740991),
        q70: z.int().gte(0).lte(9007199254740991)
    }),
    totals: z.record(z.string(), z.int().gte(0).lte(9007199254740991)),
    page: zRankingControlPage
});

export const zStudentRankingReport = z.object({
    id: z.string(),
    type: z.enum([
        'my_data_wrong',
        'my_position_wrong',
        'other'
    ]),
    description: z.union([
        z.string(),
        z.null()
    ]),
    hasFile: z.boolean(),
    versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
    state: z.enum([
        'open',
        'closed_no_change',
        'closed_corrected'
    ]),
    response: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zManagerRankingReport = z.object({
    id: z.string(),
    type: z.enum([
        'my_data_wrong',
        'my_position_wrong',
        'other'
    ]),
    state: z.enum([
        'open',
        'closed_no_change',
        'closed_corrected'
    ]),
    versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
    hasFile: z.boolean(),
    createdAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    student: z.object({
        submissionId: z.string(),
        studentId: z.union([
            z.string(),
            z.null()
        ]),
        protocol: z.string(),
        lastName: z.string(),
        firstName: z.string()
    }),
    description: z.union([
        z.string(),
        z.null()
    ]),
    response: z.union([
        z.string(),
        z.null()
    ]),
    fact: z.union([
        z.object({
            type: z.enum(['requirement_flag', 'application_submission_correction']),
            id: z.string()
        }),
        z.null()
    ]),
    closedByName: z.union([
        z.string(),
        z.null()
    ]),
    candidateFacts: z.array(z.object({
        type: z.enum(['requirement_flag', 'application_submission_correction']),
        id: z.string(),
        recordedAt: zInstantOutput,
        subject: z.string()
    })),
    candidate: z.object({
        category: z.nullable(z.enum([
            'first_year',
            'later_years',
            'doctoral_and_specialization'
        ])),
        list: z.nullable(z.enum([
            'freshers',
            'later_years',
            'doctoral'
        ])),
        listPosition: z.union([
            z.int().gt(0).lte(9007199254740991),
            z.null()
        ]),
        q70Position: z.union([
            z.int().gt(0).lte(9007199254740991),
            z.null()
        ]),
        score: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        outcome: z.nullable(z.enum([
            'assigned',
            'no_seat',
            'not_admitted',
            'excluded',
            'withdrawn',
            'forfeited'
        ])),
        versionNumber: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    })
});

export const zManagerRankingReportSummary = z.object({
    id: z.string(),
    type: z.enum([
        'my_data_wrong',
        'my_position_wrong',
        'other'
    ]),
    state: z.enum([
        'open',
        'closed_no_change',
        'closed_corrected'
    ]),
    versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
    hasFile: z.boolean(),
    createdAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    student: z.object({
        submissionId: z.string(),
        studentId: z.union([
            z.string(),
            z.null()
        ]),
        protocol: z.string(),
        lastName: z.string(),
        firstName: z.string()
    })
});

export const zRequirementFlagListRow = z.object({
    id: z.string(),
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.union([
        z.string(),
        z.null()
    ]),
    firstName: z.union([
        z.string(),
        z.null()
    ]),
    code: z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ]),
    facts: zRequirementFlagFacts,
    quotas: z.array(z.enum(['q30', 'q70'])),
    state: z.enum([
        'open',
        'awaiting_clarification',
        'clarification_received',
        'clarification_expired',
        'resolved_confirmed',
        'resolved_corrected'
    ]),
    dueAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewing: z.union([
        z.object({
            name: z.union([
                z.string(),
                z.null()
            ]),
            since: zInstantOutput
        }),
        z.null()
    ]),
    outcome: z.union([
        z.object({
            resolution: z.enum(['confirmed', 'corrected']),
            causeCode: z.enum([
                'iseeu_documented_above',
                'ispeu_documented_above',
                'cfu_documented_below',
                'offsite_not_met_documented',
                'not_proven_after_clarification',
                'declared_value_differs',
                'document_missing',
                'document_unreadable',
                'document_inconsistent'
            ]),
            correctedValue: z.union([
                z.number(),
                z.string(),
                z.null()
            ]),
            evidence: z.union([
                z.object({
                    kind: z.enum(['file']),
                    fileId: z.string(),
                    page: z.int().gt(0).lte(9007199254740991)
                }),
                z.object({
                    kind: z.enum(['clarification_expired'])
                })
            ]),
            by: z.union([
                z.string(),
                z.null()
            ]),
            at: zInstantOutput
        }),
        z.null()
    ]),
    clarification: z.union([
        z.object({
            causeCode: z.enum([
                'iseeu_documented_above',
                'ispeu_documented_above',
                'cfu_documented_below',
                'offsite_not_met_documented',
                'not_proven_after_clarification',
                'declared_value_differs',
                'document_missing',
                'document_unreadable',
                'document_inconsistent'
            ]),
            question: z.string(),
            askedAt: zInstantOutput,
            dueAt: zInstantOutput,
            answer: z.union([
                z.object({
                    text: z.string(),
                    answeredAt: zInstantOutput,
                    file: z.union([
                        z.object({
                            name: z.string()
                        }),
                        z.null()
                    ])
                }),
                z.null()
            ]),
            expiredAt: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    dueSoon: z.boolean()
});

export const zRequirementFlagCounters = z.object({
    open: z.int().gte(-9007199254740991).lte(9007199254740991),
    byState: z.record(z.string(), z.int().gte(-9007199254740991).lte(9007199254740991)),
    byCode: z.record(z.string(), z.int().gte(-9007199254740991).lte(9007199254740991))
});

export const zRequirementFlagRow = z.object({
    id: z.string(),
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.union([
        z.string(),
        z.null()
    ]),
    firstName: z.union([
        z.string(),
        z.null()
    ]),
    code: z.enum([
        'iseeu_above',
        'ispeu_above',
        'cfu_below_min',
        'offsite_not_met'
    ]),
    facts: zRequirementFlagFacts,
    quotas: z.array(z.enum(['q30', 'q70'])),
    state: z.enum([
        'open',
        'awaiting_clarification',
        'clarification_received',
        'clarification_expired',
        'resolved_confirmed',
        'resolved_corrected'
    ]),
    dueAt: z.union([
        z.string(),
        z.null()
    ]),
    reviewing: z.union([
        z.object({
            name: z.union([
                z.string(),
                z.null()
            ]),
            since: zInstantOutput
        }),
        z.null()
    ]),
    outcome: z.union([
        z.object({
            resolution: z.enum(['confirmed', 'corrected']),
            causeCode: z.enum([
                'iseeu_documented_above',
                'ispeu_documented_above',
                'cfu_documented_below',
                'offsite_not_met_documented',
                'not_proven_after_clarification',
                'declared_value_differs',
                'document_missing',
                'document_unreadable',
                'document_inconsistent'
            ]),
            correctedValue: z.union([
                z.number(),
                z.string(),
                z.null()
            ]),
            evidence: z.union([
                z.object({
                    kind: z.enum(['file']),
                    fileId: z.string(),
                    page: z.int().gt(0).lte(9007199254740991)
                }),
                z.object({
                    kind: z.enum(['clarification_expired'])
                })
            ]),
            by: z.union([
                z.string(),
                z.null()
            ]),
            at: zInstantOutput
        }),
        z.null()
    ]),
    clarification: z.union([
        z.object({
            causeCode: z.enum([
                'iseeu_documented_above',
                'ispeu_documented_above',
                'cfu_documented_below',
                'offsite_not_met_documented',
                'not_proven_after_clarification',
                'declared_value_differs',
                'document_missing',
                'document_unreadable',
                'document_inconsistent'
            ]),
            question: z.string(),
            askedAt: zInstantOutput,
            dueAt: zInstantOutput,
            answer: z.union([
                z.object({
                    text: z.string(),
                    answeredAt: zInstantOutput,
                    file: z.union([
                        z.object({
                            name: z.string()
                        }),
                        z.null()
                    ])
                }),
                z.null()
            ]),
            expiredAt: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zRequirementFlagDetail = z.object({
    flag: zRequirementFlagRow,
    submission: z.object({
        id: z.string(),
        protocol: z.string(),
        origin: z.enum(['platform', 'direct_pec']),
        category: z.union([
            z.string(),
            z.null()
        ]),
        quotas: z.object({
            q30: z.boolean(),
            q70: z.boolean()
        })
    }),
    files: z.array(z.object({
        id: z.string(),
        kind: z.enum([
            'signed_annex_a',
            'document',
            'direct_message'
        ]),
        documentKind: z.nullable(z.enum([
            'identity',
            'enrollment',
            'iseeu_ispeu',
            'credits_screenshot',
            'doctoral_enrollment',
            'disability'
        ])),
        filename: z.string(),
        relevant: z.boolean()
    })),
    causes: z.array(z.object({
        code: z.enum([
            'iseeu_documented_above',
            'ispeu_documented_above',
            'cfu_documented_below',
            'offsite_not_met_documented',
            'not_proven_after_clarification',
            'declared_value_differs',
            'document_missing',
            'document_unreadable',
            'document_inconsistent'
        ]),
        outcome: z.enum([
            'not_met',
            'corrected',
            'clarification'
        ]),
        text: z.string()
    })),
    pecReply: z.union([
        z.object({
            subject: z.string(),
            text: z.string()
        }),
        z.null()
    ])
});

export const zResidenceManagerPerson = z.object({
    firstName: z.string().min(1).max(50),
    lastName: z.string().min(1).max(50),
    email: z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    language: z.optional(z.enum(['en', 'it']))
});

export const zResidenceCreate = z.object({
    name: z.string().min(1).max(200),
    manager: zResidenceManagerPerson
});

export const zResidenceSiteData = z.object({
    id: z.optional(z.string()),
    name: z.string().min(1).max(200),
    address: z.string().min(1).max(300),
    city: z.string().min(1).max(120),
    typology: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    singleBeds: z.int().gte(0).lte(10000),
    doubleBeds: z.int().gte(0).lte(10000),
    bathroomsCount: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    bathroomsDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    kitchensCount: z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ]),
    kitchensDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    otherServicesDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedSingleBeds: z.int().gte(0).lte(10000),
    equippedDoubleBeds: z.int().gte(0).lte(10000),
    equippedBathroomsDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedKitchensDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ]),
    equippedOtherServicesDescription: z.union([
        z.string().min(1).max(500),
        z.null()
    ])
});

export const zResidenceManagerData = z.object({
    firstName: z.string().min(1).max(50),
    lastName: z.string().min(1).max(50),
    email: z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    language: z.optional(z.enum(['en', 'it'])),
    residenceId: z.string()
});

export const zResidenceManager = z.object({
    id: z.string(),
    residenceIds: z.array(z.string()),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    status: zBackofficeAdminStatus,
    invitedAt: zInstantOutput,
    lastSignInAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zMailboxTestStatus = z.object({
    id: z.string(),
    residenceId: z.string(),
    address: z.string(),
    delivery: z.enum([
        'sending',
        'delivered',
        'refused'
    ]),
    sentAt: zInstantOutput,
    confirmedAt: z.union([
        z.string(),
        z.null()
    ]),
    confirmedByName: z.union([
        z.string(),
        z.null()
    ]),
    attemptsLeft: z.int().gte(0).lte(9007199254740991)
});

export const zDsuRate = z.object({
    singleRateCents: z.int().gte(-9007199254740991).lte(9007199254740991),
    doubleRateCents: z.int().gte(-9007199254740991).lte(9007199254740991),
    setAt: zInstantOutput
});

export const zResidenceSending = z.object({
    residence: z.object({
        id: z.string(),
        name: z.string()
    }),
    openAnomalies: z.object({
        transmission_not_delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
        email_bounced: z.int().gte(-9007199254740991).lte(9007199254740991),
        ranking_failed: z.int().gte(-9007199254740991).lte(9007199254740991),
        offer_not_sent: z.int().gte(-9007199254740991).lte(9007199254740991),
        offer_bounced: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    applications: zApplicationSendingCounters
});

export const zSendingAnomalyItem = z.object({
    id: z.string(),
    kind: z.enum([
        'transmission_not_delivered',
        'email_bounced',
        'ranking_failed',
        'offer_not_sent',
        'offer_bounced'
    ]),
    residence: z.union([
        z.object({
            id: z.string(),
            name: z.string()
        }),
        z.null()
    ]),
    protocol: z.union([
        z.string(),
        z.null()
    ]),
    reason: z.string(),
    openedAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    closeNote: z.union([
        z.string(),
        z.null()
    ]),
    notifiedManagerAt: z.union([
        z.string(),
        z.null()
    ]),
    canNotifyManager: z.boolean()
});

export const zSendingAnomalyDetail = z.object({
    anomaly: zSendingAnomalyItem,
    submission: z.union([
        z.object({
            id: z.string(),
            protocol: z.string(),
            submittedAt: z.union([
                z.string(),
                z.null()
            ]),
            effectiveAt: z.union([
                z.string(),
                z.null()
            ]),
            effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival']))
        }),
        z.null()
    ])
});

export const zSendingAnomalyRecipient = z.object({
    recipient: z.union([
        z.string(),
        z.null()
    ]),
    recipientId: z.union([
        z.string(),
        z.null()
    ])
});

export const zStudentProfileUpdate = z.object({
    lastName: z.optional(z.union([
        z.string().min(1).max(100),
        z.null()
    ])),
    firstName: z.optional(z.union([
        z.string().min(1).max(100),
        z.null()
    ])),
    birthDate: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    birthMunicipalityIstatCode: z.optional(z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ])),
    birthCountryCode: z.optional(z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ])),
    taxCode: z.optional(z.union([
        z.string().regex(/^[A-Za-z0-9]{16}$/),
        z.null()
    ])),
    passportNumber: z.optional(z.union([
        z.string().min(5).max(30),
        z.null()
    ])),
    phone: z.optional(z.union([
        z.string().regex(/^\+[1-9]\d{6,14}$/),
        z.null()
    ])),
    familyAbroad: z.optional(z.boolean()),
    residenceAddress: z.optional(z.union([
        z.string().min(1).max(200),
        z.null()
    ])),
    residencePostalCode: z.optional(z.union([
        z.string().regex(/^\d{5}$/),
        z.null()
    ])),
    residenceMunicipalityIstatCode: z.optional(z.union([
        z.string().regex(/^\d{6}$/),
        z.null()
    ])),
    residenceCountryCode: z.optional(z.union([
        z.string().regex(/^[A-Za-z]{2}$/),
        z.null()
    ])),
    institutionCode: z.optional(z.union([
        z.string().min(1).max(10),
        z.null()
    ])),
    campusCode: z.optional(z.union([
        z.string().min(1).max(20),
        z.null()
    ])),
    courseName: z.optional(z.union([
        z.string().min(1).max(200),
        z.null()
    ])),
    campusAddress: z.optional(z.union([
        z.string().min(1).max(200),
        z.null()
    ])),
    courseType: z.optional(z.nullable(z.enum([
        'bachelor',
        'master',
        'single_cycle',
        'phd',
        'specialization'
    ]))),
    enrollmentYear: z.optional(z.union([
        z.int().gte(1).lte(6),
        z.null()
    ])),
    studentNumber: z.optional(z.union([
        z.string().min(1).max(30),
        z.null()
    ])),
    preEnrollmentNumber: z.optional(z.union([
        z.string().min(1).max(30),
        z.null()
    ])),
    credits: z.optional(z.union([
        z.int().gte(0).lte(1000),
        z.null()
    ])),
    extraSemester: z.optional(z.boolean()),
    gradeAverage: z.optional(z.union([
        z.number().gte(18).lte(30),
        z.null()
    ])),
    iseeDeclared: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    iseeuCents: z.optional(z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ])),
    ispeuCents: z.optional(z.union([
        z.int().gte(0).lte(2000000000),
        z.null()
    ]))
});

export const zStudentProfileError = z.object({
    field: z.string(),
    code: z.enum([
        'tax_code_format',
        'tax_code_mismatch',
        'tax_code_unavailable',
        'municipality_unknown',
        'country_unknown',
        'text_not_printable',
        'country_not_foreign',
        'birth_place_conflict',
        'passport_not_allowed',
        'institution_unknown',
        'campus_unknown',
        'campus_not_of_institution'
    ]),
    characters: z.optional(z.array(z.string()))
});

export const zFavoriteResidence = z.object({
    slug: z.string(),
    name: z.string(),
    city: z.string(),
    callState: z.enum([
        'published',
        'open',
        'closed'
    ]),
    addedAt: zInstantOutput
});

export const zFavoriteList = z.object({
    favorites: z.array(zFavoriteResidence)
});

export const zSupportStudentItem = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.string(),
        z.null()
    ]),
    applications: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zSupportRequest = z.object({
    id: z.string(),
    summary: z.string(),
    openedAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    answer: z.union([
        z.string(),
        z.null()
    ])
});

export const zSupportStudent = z.object({
    account: z.object({
        id: z.string(),
        email: z.union([
            z.string(),
            z.null()
        ]),
        name: z.string(),
        status: z.enum([
            'active',
            'banned',
            'deleted'
        ]),
        emailVerifiedAt: z.union([
            z.string(),
            z.null()
        ]),
        createdAt: zInstantOutput
    }),
    applications: z.array(z.object({
        id: z.string(),
        applicationId: z.union([
            z.string(),
            z.null()
        ]),
        residence: z.object({
            id: z.string(),
            name: z.string()
        }),
        protocol: z.string(),
        state: z.enum([
            'submitted',
            'superseded',
            'withdrawn'
        ]),
        submittedAt: z.union([
            z.string(),
            z.null()
        ]),
        effectiveAt: z.union([
            z.string(),
            z.null()
        ]),
        effectiveBasis: z.nullable(z.enum(['submitted', 'pec_arrival'])),
        reviewState: z.nullable(z.enum([
            'awaiting',
            'acknowledged',
            'problem'
        ])),
        reviewedAt: z.union([
            z.string(),
            z.null()
        ]),
        transmissionState: z.nullable(z.enum([
            'sending',
            'delivered',
            'not_delivered'
        ]))
    })),
    emails: z.array(z.object({
        id: z.string(),
        template: z.string(),
        toAddress: z.string(),
        state: z.enum([
            'queued',
            'sent',
            'delivered',
            'bounced',
            'complained',
            'failed'
        ]),
        bounceType: z.nullable(z.enum(['permanent', 'transient'])),
        createdAt: zInstantOutput
    })),
    requests: z.array(zSupportRequest)
});

export const zSupportOpenRequestItem = z.object({
    id: z.string(),
    summary: z.string(),
    openedAt: zInstantOutput,
    closedAt: z.union([
        z.string(),
        z.null()
    ]),
    answer: z.union([
        z.string(),
        z.null()
    ]),
    student: z.object({
        id: z.string(),
        name: z.string(),
        email: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zUser = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])),
    gender: z.nullable(z.enum([
        'male',
        'female',
        'non_binary',
        'prefer_not_to_say'
    ])),
    emailStatus: z.enum([
        'none',
        'unverified',
        'verified'
    ]),
    createdAt: zInstantOutput
});

export const zUserGender = z.enum([
    'male',
    'female',
    'non_binary',
    'prefer_not_to_say'
]);

export const zVerificationListRow = z.object({
    id: z.string(),
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.union([
        z.string(),
        z.null()
    ]),
    firstName: z.union([
        z.string(),
        z.null()
    ]),
    quota: z.enum(['q30', 'q70']),
    category: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    state: z.enum([
        'pending',
        'compliant',
        'excluded'
    ]),
    acceptedAt: z.union([
        z.string(),
        z.null()
    ]),
    itemsToCheck: z.array(z.enum([
        'identity',
        'signed_annex',
        'enrollment',
        'economic',
        'credits'
    ])),
    studentNumberMissing: z.boolean(),
    decidedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zVerificationCounters = z.object({
    pending: z.int().gte(-9007199254740991).lte(9007199254740991),
    compliant: z.int().gte(-9007199254740991).lte(9007199254740991),
    excluded: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zVerificationChecklistDifference = z.object({
    field: z.enum([
        'iseeuCents',
        'ispeuCents',
        'credits'
    ]),
    declaredValue: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    documentedValue: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zVerificationChecklistEntry = z.object({
    state: z.enum(['matches', 'differs_no_effect']),
    differences: z.union([
        z.array(zVerificationChecklistDifference),
        z.null()
    ]),
    note: z.union([
        z.string(),
        z.null()
    ]),
    checkedBy: z.string(),
    checkedAt: zInstantOutput
});

export const zVerificationExclusion = z.object({
    id: z.string(),
    item: z.enum([
        'identity',
        'signed_annex',
        'enrollment',
        'economic',
        'credits'
    ]),
    causeCode: z.enum([
        'identity_document_invalid',
        'duplicate_application',
        'annex_not_valid',
        'enrollment_missing',
        'iseeu_documented_differs',
        'ispeu_documented_differs',
        'cfu_documented_differs'
    ]),
    causeText: z.string(),
    documentedValue: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    note: z.union([
        z.string(),
        z.null()
    ]),
    recordedByName: z.union([
        z.string(),
        z.null()
    ]),
    recordedAt: zInstantOutput,
    correction: z.union([
        z.object({
            note: z.union([
                z.string(),
                z.null()
            ]),
            correctedByName: z.union([
                z.string(),
                z.null()
            ]),
            correctedAt: zInstantOutput
        }),
        z.null()
    ])
});

export const zVerificationDetail = z.object({
    verification: zVerificationListRow,
    disabilityPriority: z.nullable(z.enum(['held', 'revoked'])),
    seatHeld: z.boolean(),
    submission: z.object({
        id: z.string(),
        protocol: z.string(),
        origin: z.enum(['platform', 'direct_pec'])
    }),
    declared: z.object({
        lastName: z.union([
            z.string(),
            z.null()
        ]),
        firstName: z.union([
            z.string(),
            z.null()
        ]),
        birthDate: z.union([
            z.string(),
            z.null()
        ]),
        taxCode: z.union([
            z.string(),
            z.null()
        ]),
        passportNumber: z.union([
            z.string(),
            z.null()
        ]),
        institutionCode: z.union([
            z.string(),
            z.null()
        ]),
        courseName: z.union([
            z.string(),
            z.null()
        ]),
        enrollmentYear: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        studentNumber: z.union([
            z.string(),
            z.null()
        ]),
        preEnrollmentNumber: z.union([
            z.string(),
            z.null()
        ]),
        credits: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        iseeuCents: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        ispeuCents: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ])
    }),
    items: z.array(z.object({
        item: z.enum([
            'identity',
            'signed_annex',
            'enrollment',
            'economic',
            'credits'
        ]),
        entry: z.union([
            z.object({
                state: z.enum(['matches', 'differs_no_effect']),
                differences: z.union([
                    z.array(zVerificationChecklistDifference),
                    z.null()
                ]),
                note: z.union([
                    z.string(),
                    z.null()
                ]),
                checkedBy: z.string(),
                checkedAt: zInstantOutput
            }),
            z.null()
        ])
    })),
    studentNumber: z.object({
        required: z.boolean(),
        requestedAt: z.union([
            z.string(),
            z.null()
        ]),
        recorded: z.union([
            z.string(),
            z.null()
        ]),
        receivedAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    files: z.array(z.object({
        id: z.string(),
        kind: z.enum([
            'signed_annex_a',
            'document',
            'direct_message'
        ]),
        documentKind: z.nullable(z.enum([
            'identity',
            'enrollment',
            'iseeu_ispeu',
            'credits_screenshot',
            'doctoral_enrollment',
            'disability'
        ])),
        filename: z.string(),
        item: z.nullable(z.enum([
            'identity',
            'signed_annex',
            'enrollment',
            'economic',
            'credits'
        ]))
    })),
    exclusionCauses: z.array(z.object({
        code: z.enum([
            'identity_document_invalid',
            'duplicate_application',
            'annex_not_valid',
            'enrollment_missing',
            'iseeu_documented_differs',
            'ispeu_documented_differs',
            'cfu_documented_differs'
        ]),
        text: z.string(),
        item: z.enum([
            'identity',
            'signed_annex',
            'enrollment',
            'economic',
            'credits'
        ])
    })),
    exclusions: z.array(zVerificationExclusion)
});

export const zVerificationNeighbors = z.object({
    previousId: z.union([
        z.string(),
        z.null()
    ]),
    nextId: z.union([
        z.string(),
        z.null()
    ])
});

export const zVerificationDocumentedValues = z.object({
    iseeuCents: z.optional(z.int().gte(0).lte(9007199254740991)),
    ispeuCents: z.optional(z.int().gte(0).lte(9007199254740991)),
    credits: z.optional(z.int().gte(0).lte(9007199254740991))
});

export const zVerificationDocumentedStanding = z.object({
    position: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    admission: z.object({
        q30: z.enum([
            'admitted',
            'not_admitted',
            'pending'
        ]),
        q70: z.enum([
            'admitted',
            'not_admitted',
            'pending'
        ])
    })
});

export const zVerificationDocumentedValueEffect = z.object({
    differences: z.array(zVerificationChecklistDifference),
    admissionChanged: z.boolean(),
    positionChanged: z.boolean(),
    adverse: z.boolean(),
    before: zVerificationDocumentedStanding,
    after: zVerificationDocumentedStanding
});

export const zRoomOverviewRow = z.object({
    offerId: z.string(),
    submissionId: z.string(),
    studentId: z.union([
        z.string(),
        z.null()
    ]),
    protocol: z.string(),
    lastName: z.union([
        z.string(),
        z.null()
    ]),
    firstName: z.union([
        z.string(),
        z.null()
    ]),
    quota: z.enum(['q30', 'q70']),
    category: z.enum([
        'first_year',
        'later_years',
        'doctoral_and_specialization'
    ]),
    seatOrigin: z.enum([
        'ranking_order',
        'equipped_priority',
        'other_list',
        'ministry_authorization'
    ]),
    roomPreference: z.enum([
        'single',
        'double',
        'none'
    ]),
    acceptedAt: z.union([
        z.string(),
        z.null()
    ]),
    verificationId: z.union([
        z.string(),
        z.null()
    ]),
    verificationState: z.nullable(z.enum([
        'pending',
        'compliant',
        'excluded'
    ])),
    itemsToCheck: z.array(z.enum([
        'identity',
        'signed_annex',
        'enrollment',
        'economic',
        'credits'
    ])),
    studentNumberMissing: z.boolean(),
    forfeit: z.union([
        z.object({
            kind: z.enum([
                'verification_exclusion',
                'contract_not_signed',
                'written_renunciation'
            ]),
            causeText: z.string(),
            factDate: z.union([
                z.string(),
                z.null()
            ]),
            recordedAt: zInstantOutput
        }),
        z.null()
    ]),
    checkInBlockedReason: z.nullable(z.enum([
        'offer_not_accepted',
        'verification_not_compliant',
        'room_not_proposed'
    ])),
    assignment: z.union([
        z.object({
            sitePosition: z.int().gte(-9007199254740991).lte(9007199254740991),
            siteName: z.union([
                z.string(),
                z.null()
            ]),
            roomType: z.enum(['single', 'double']),
            equipped: z.boolean(),
            state: z.enum(['room_proposed', 'checked_in']),
            proposedAt: zInstantOutput,
            checkInDate: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zAfterAcceptanceCause = z.object({
    code: z.enum(['contract_not_signed', 'written_renunciation']),
    text: z.string()
});

export const zRoomQuotaCount = z.object({
    quota: z.enum(['q30', 'q70']),
    roomType: z.enum(['single', 'double']),
    used: z.int().gte(-9007199254740991).lte(9007199254740991),
    total: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zRoomSiteCount = z.object({
    position: z.int().gte(-9007199254740991).lte(9007199254740991),
    name: z.string(),
    address: z.string(),
    city: z.string(),
    roomType: z.enum(['single', 'double']),
    used: z.int().gte(-9007199254740991).lte(9007199254740991),
    total: z.int().gte(-9007199254740991).lte(9007199254740991),
    equippedUsed: z.int().gte(-9007199254740991).lte(9007199254740991),
    equippedTotal: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zDsuMinistryAnswerView = z.object({
    state: z.enum([
        'none',
        'granted',
        'denied',
        'unlocked'
    ]),
    callClosed: z.boolean(),
    answeredOn: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    recordedAt: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    recordedByName: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    unlockedAt: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    unlockedByName: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    unlockReason: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

export const zDsuQuotaSeats = z.object({
    covered: z.array(z.object({
        offerId: z.string(),
        submissionId: z.string(),
        studentId: z.union([
            z.string(),
            z.null()
        ]),
        protocol: z.string(),
        lastName: z.union([
            z.string(),
            z.null()
        ]),
        firstName: z.union([
            z.string(),
            z.null()
        ])
    })),
    inProgress: z.array(z.object({
        offerId: z.string(),
        protocol: z.string()
    })),
    beyond: z.int().gte(-9007199254740991).lte(9007199254740991),
    uncoveredSince: z.union([
        z.string(),
        z.null()
    ])
});

export const zDsuQuotaHistoryRow = z.object({
    fundedBeds: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    threshold: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    dsuSeats: z.int().gte(-9007199254740991).lte(9007199254740991),
    gap: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    belowThreshold: z.boolean(),
    q30Seats: z.int().gte(-9007199254740991).lte(9007199254740991),
    covered: z.int().gte(-9007199254740991).lte(9007199254740991),
    inProgress: z.int().gte(-9007199254740991).lte(9007199254740991),
    uncovered: z.int().gte(-9007199254740991).lte(9007199254740991),
    unassigned: z.int().gte(-9007199254740991).lte(9007199254740991),
    id: z.string(),
    computedAt: zInstantOutput,
    cause: z.enum([
        'offer.accepted',
        'ranking.calculated',
        'residence.funded_beds_corrected',
        'offers.launched',
        'dsu_quota.reconciled'
    ])
});

export const zResidenceData = z.object({
    name: z.string().min(1).max(200),
    operatorLegalName: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    grantDecree: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    dpoContact: z.union([
        z.string().min(1).max(300),
        z.null()
    ]),
    infoEmail: z.union([
        z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    sites: z.array(zResidenceSiteData).max(3),
    pecAddress: z.union([
        z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    q30SingleBeds: z.int().gte(0).lte(10000),
    q30DoubleBeds: z.int().gte(0).lte(10000),
    q70SingleBeds: z.int().gte(0).lte(10000),
    q70DoubleBeds: z.int().gte(0).lte(10000),
    fundedBeds: z.union([
        z.int().gte(0).lte(10000),
        z.null()
    ]),
    q70SingleRateCents: z.union([
        z.int().gte(0).lte(1000000),
        z.null()
    ]),
    q70DoubleRateCents: z.union([
        z.int().gte(0).lte(1000000),
        z.null()
    ]),
    services: z.array(z.enum([
        'study_room',
        'library',
        'common_kitchen',
        'common_room',
        'laundry',
        'garden',
        'wifi',
        'air_conditioning',
        'bed_linen',
        'cleaning',
        'private_bathroom',
        'canteen',
        'vending',
        'security',
        'gym',
        'sports_field',
        'bike_parking',
        'parking',
        'shuttle',
        'elevator'
    ])).max(20),
    admittedInstitutions: z.array(z.string().min(1).max(10)).max(50),
    callLinkUrl: z.union([
        z.url(),
        z.null()
    ]),
    contractSigningDays: z.union([
        z.int().gte(1).lte(90),
        z.null()
    ]),
    contractSigningInstructions: z.union([
        z.string().min(1).max(2000),
        z.null()
    ]),
    depositInstructions: z.union([
        z.string().min(1).max(2000),
        z.null()
    ]),
    iban: z.union([
        z.string().max(34),
        z.null()
    ]),
    bankAccountHolder: z.union([
        z.string().min(1).max(2000),
        z.null()
    ])
});

export const zDocsSchemaData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zAdminBanUserData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string(),
            reason: z.optional(z.string().max(500)),
            expiresAt: z.optional(zInstant)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminBanUserResponse2 = z.object({
    data: zAdminBanUserResponse
});

export const zAdminUnbanUserData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminUnbanUserResponse2 = z.object({
    data: zAdminUnbanUserResponse
});

export const zAdminDeleteUserData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string(),
            reason: z.string().min(1).max(500),
            requestReference: z.optional(z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:\/-]{0,63}$/))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminDeleteUserResponse2 = z.object({
    data: zAdminDeleteUserResponse
});

export const zAdminListUsersData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            status: z.optional(z.union([
                z.array(z.enum([
                    'active',
                    'banned',
                    'deleted'
                ])).min(1).max(3),
                z.null()
            ])),
            banned: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            emailVerified: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            createdAt: z.optional(zInstantRange)
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminListUsersResponse = z.object({
    data: z.array(zAdminUserListItem),
    meta: zOffsetPaginationMeta
});

export const zAdminExportUsersData = z.object({
    body: z.object({
        format: z.enum(['csv', 'xlsx']),
        mode: z.optional(z.enum([
            'auto',
            'sync',
            'async'
        ])),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            status: z.optional(z.union([
                z.array(z.enum([
                    'active',
                    'banned',
                    'deleted'
                ])).min(1).max(3),
                z.null()
            ])),
            banned: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            emailVerified: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            createdAt: z.optional(zInstantRange)
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zAdminExportUsersResponse = z.union([
    z.string(),
    z.object({
        data: z.object({
            id: z.string(),
            dataset: z.string(),
            format: z.enum(['csv', 'xlsx']),
            status: z.enum(['pending']),
            rowCount: z.int().gte(0).lte(9007199254740991),
            fileName: z.string(),
            expiresAt: zInstantOutput
        })
    })
]);

export const zAdminGetHomeData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminGetHomeResponse = z.object({
    data: zAdminHome
});

export const zAdminGetUserSessionsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: zAdminUserSessionsFilter
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAdminGetUserSessionsResponse = z.object({
    data: z.array(zAdminUserSessionItem),
    meta: zOffsetPaginationMeta
});

export const zApplicationGetDraftData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetDraftResponse = z.object({
    data: z.union([
        z.object({
            application: zApplicationDraft,
            profile: zStudentProfileView,
            choices: z.array(zApplicationChoice),
            transmissionLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
            withdrawalOnAcceptance: z.string(),
            disabilityDocument: z.union([
                z.string(),
                z.null()
            ]),
            sections: z.object({
                personal: zApplicationSectionState,
                enrollment: zApplicationSectionState,
                economic: zApplicationSectionState,
                residences: zApplicationSectionState,
                declarations_and_documents: zApplicationSectionState,
                summary: zApplicationSectionState
            }),
            declarations: z.array(zApplicationDeclaration),
            documents: z.array(zApplicationDocument),
            warnings: z.array(zApplicationWarning),
            eligibility: z.array(zEligibilityForVersion),
            notices: z.array(z.enum(['no_quota_left'])),
            unreadNotices: z.array(zApplicationUnreadNotice),
            currentSection: z.enum([
                'personal',
                'enrollment',
                'economic',
                'residences',
                'declarations_and_documents',
                'summary'
            ])
        }),
        z.null()
    ])
});

export const zApplicationStartDraftData = z.object({
    body: z.object({
        fromResidenceSlug: z.optional(z.string().min(1).max(128))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationStartDraftResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationConfirmWarningsData = z.object({
    body: z.object({
        data: zConfirmWarnings
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationConfirmWarningsResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationUpdateData = z.object({
    body: z.object({
        data: zApplicationUpdate
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationUpdateResponse = z.object({
    data: zApplicationUpdatedView
});

export const zApplicationDownloadAnnexAPreviewData = z.object({
    body: z.object({
        residenceId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The preview of the Allegato A addressed to the operator of the residence, as a PDF attachment, named `allegato-a-anteprima-{slug}.pdf`.
 */
export const zApplicationDownloadAnnexAPreviewResponse = z.string();

export const zApplicationDownloadAnnexAForSignatureData = z.object({
    body: z.object({
        residenceId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The Allegato A to sign by hand, addressed to the operator of the residence, as a PDF attachment, named `allegato-a-{slug}-da-firmare.pdf`.
 */
export const zApplicationDownloadAnnexAForSignatureResponse = z.string();

export const zApplicationCreateSignedAnnexUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCreateSignedAnnexUploadResponse = z.object({
    data: zCreatedAsset
});

export const zApplicationConfirmSignedAnnexData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            assetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationConfirmSignedAnnexResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationSetDeclarationsData = z.object({
    body: z.object({
        data: zSetDeclarations
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationSetDeclarationsResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationCheckReadyData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCheckReadyResponse = z.object({
    data: zApplicationReadiness
});

export const zApplicationMarkNoticesSeenData = z.object({
    body: z.object({
        noticeIds: z.array(z.string()).max(50)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationMarkNoticesSeenResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationListAvailableResidencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationListAvailableResidencesResponse = z.object({
    data: zAvailableResidences
});

export const zApplicationRemoveAllResidencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationRemoveAllResidencesResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationAddAllResidencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationAddAllResidencesResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationRemoveResidenceData = z.object({
    body: z.object({
        residenceId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationRemoveResidenceResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationAddResidenceData = z.object({
    body: z.object({
        residenceId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationAddResidenceResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationCreateDocumentUploadData = z.object({
    body: z.object({
        data: z.object({
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCreateDocumentUploadResponse = z.object({
    data: zCreatedAsset
});

export const zApplicationConfirmDocumentData = z.object({
    body: z.object({
        data: z.object({
            kind: z.enum([
                'identity',
                'enrollment',
                'iseeu_ispeu',
                'credits_screenshot',
                'doctoral_enrollment',
                'disability'
            ]),
            assetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationConfirmDocumentResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationRemoveDocumentData = z.object({
    body: z.object({
        data: z.object({
            documentId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationRemoveDocumentResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationDownloadDocumentData = z.object({
    body: z.object({
        data: z.object({
            documentId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationDownloadDocumentResponse = z.object({
    data: z.object({
        url: z.string(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zApplicationSubmitData = z.object({
    body: z.object({
        data: z.object({
            applicationId: z.string(),
            residenceIds: z.array(z.string()).min(1)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationSubmitResponse = z.object({
    data: z.object({
        submittedAt: zInstantOutput,
        submissions: z.array(z.object({
            id: z.string(),
            residenceId: z.string(),
            callId: z.string(),
            academicYear: zAcademicYear,
            protocol: z.string()
        }))
    })
});

export const zApplicationStartReplacementData = z.object({
    body: z.object({
        residenceId: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationStartReplacementResponse = z.object({
    data: zApplicationDraftView
});

export const zApplicationWithdrawData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string(),
            confirmLast: z.optional(z.boolean()).default(false)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationWithdrawResponse = z.object({
    data: z.object({
        ok: z.literal(true)
    })
});

export const zApplicationDownloadReceiptData = z.object({
    body: z.object({
        data: z.object({
            applicationId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The receipt of the signature as a PDF attachment, named `ricevuta-domande-{yyyymmdd}.pdf`, the day of the signature in the time of Rome.
 */
export const zApplicationDownloadReceiptResponse = z.string();

export const zApplicationListSubmissionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationListSubmissionsResponse = z.object({
    data: z.array(zApplicationSubmissionSummary)
});

export const zApplicationGetSubmissionData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetSubmissionResponse = z.object({
    data: zApplicationSubmissionDetail
});

export const zApplicationGetClarificationData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetClarificationResponse = z.object({
    data: z.array(zStudentClarification)
});

export const zApplicationAnswerClarificationData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string(),
            flagId: z.string(),
            text: z.string().min(1).max(4000),
            assetId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationAnswerClarificationResponse = z.object({
    data: z.object({
        state: z.enum(['clarification_received']),
        answeredAt: zInstantOutput
    })
});

export const zApplicationDownloadSubmittedFileData = z.object({
    body: z.object({
        data: z.object({
            fileId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationDownloadSubmittedFileResponse = z.object({
    data: z.object({
        url: z.string(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zApplicationListForResidenceData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            state: z.optional(z.enum([
                'submitted',
                'superseded',
                'withdrawn'
            ])),
            category: z.optional(z.enum([
                'first_year',
                'later_years',
                'doctoral_and_specialization'
            ])),
            quota: z.optional(z.enum(['q30', 'q70'])),
            reviewState: z.optional(z.enum([
                'awaiting',
                'acknowledged',
                'problem'
            ])),
            openFlags: z.optional(z.boolean()),
            flagCode: z.optional(z.enum([
                'iseeu_above',
                'ispeu_above',
                'cfu_below_min',
                'offsite_not_met'
            ])),
            origin: z.optional(z.enum(['platform', 'direct_pec'])),
            afterCall: z.optional(z.boolean()),
            search: z.optional(z.string().min(1).max(100))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationListForResidenceResponse = z.object({
    data: z.array(zApplicationManagerRow),
    meta: zOffsetPaginationMeta
});

export const zApplicationGetForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetForResidenceResponse = z.object({
    data: zApplicationManagerDetail
});

export const zApplicationGetCountersForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetCountersForResidenceResponse = z.object({
    data: zApplicationManagerCounters
});

export const zApplicationGetManagerDashboardData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetManagerDashboardResponse = z.object({
    data: zApplicationManagerDashboard
});

export const zApplicationGetStatusForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationGetStatusForResidenceResponse = z.object({
    data: zApplicationManagerStatus
});

export const zApplicationDownloadResidenceFileData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileId: z.string(),
            view: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationDownloadResidenceFileResponse = z.object({
    data: z.object({
        url: z.string(),
        inline: z.boolean(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991),
        subjectId: z.string()
    })
});

export const zApplicationAcknowledgeSubmissionData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationAcknowledgeSubmissionResponse = z.object({
    data: zApplicationReviewResult
});

export const zApplicationMarkNoticeSeenData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationMarkNoticeSeenResponse = z.object({
    data: z.object({
        marked: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zApplicationReportSubmissionProblemData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string(),
            cause: z.enum([
                'missing_signature',
                'annex_mismatch',
                'annex_unreadable',
                'identity_document_problem'
            ]),
            note: z.optional(z.string().max(500))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationReportSubmissionProblemResponse = z.object({
    data: zApplicationReviewResult
});

export const zApplicationCreateDirectMessageUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCreateDirectMessageUploadResponse = z.object({
    data: zCreatedAsset
});

export const zApplicationReadDirectMessageData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            assetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationReadDirectMessageResponse = z.object({
    data: zDirectMessageReading
});

export const zApplicationCreateDirectDocumentUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCreateDirectDocumentUploadResponse = z.object({
    data: zCreatedAsset
});

export const zApplicationFindSamePersonData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            taxCode: z.optional(z.union([
                z.string().regex(/^[A-Za-z0-9]{16}$/),
                z.null()
            ])),
            passportNumber: z.optional(z.union([
                z.string().min(5).max(30),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationFindSamePersonResponse = z.object({
    data: z.array(zSamePersonSubmission)
});

export const zApplicationCreateDirectData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            messageAssetId: z.string(),
            arrivedAt: zInstant,
            senderAddress: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            senderKind: z.enum(['pec', 'email']),
            transcription: zDirectTranscription,
            documents: z.array(z.object({
                kind: z.enum([
                    'identity',
                    'enrollment',
                    'iseeu_ispeu',
                    'credits_screenshot',
                    'doctoral_enrollment',
                    'disability'
                ]),
                assetId: z.string()
            })).max(10),
            reviewed: z.literal(true)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCreateDirectResponse = z.object({
    data: zDirectRegistration
});

export const zApplicationMarkDirectPecReplySentData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationMarkDirectPecReplySentResponse = z.object({
    data: z.object({
        pecReplySentAt: zInstantOutput
    })
});

export const zApplicationCorrectDirectData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string(),
            changes: z.array(z.object({
                field: z.enum([
                    'lastName',
                    'firstName',
                    'birthDate',
                    'birthMunicipalityIstatCode',
                    'birthCountryCode',
                    'taxCode',
                    'email',
                    'phone',
                    'familyAbroad',
                    'residenceAddress',
                    'residencePostalCode',
                    'residenceMunicipalityIstatCode',
                    'residenceCountryCode',
                    'institutionCode',
                    'campusCode',
                    'courseName',
                    'campusAddress',
                    'courseType',
                    'enrollmentYear',
                    'studentNumber',
                    'preEnrollmentNumber',
                    'credits',
                    'extraSemester',
                    'gradeAverage',
                    'iseeuCents',
                    'ispeuCents',
                    'roomPreference',
                    'excludeQ70',
                    'needsEquipped'
                ]),
                value: z.unknown()
            })).min(1).max(30)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zApplicationCorrectDirectResponse = z.object({
    data: z.object({
        corrected: z.array(z.string())
    })
});

export const zAssetsCreateAssetsData = z.object({
    body: z.object({
        data: z.object({
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991),
            scope: z.enum(['user_photo'])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAssetsCreateAssetsResponse = z.object({
    data: zCreatedAsset
});

export const zAuthSignOutData = z.object({
    body: z.object({
        token: z.optional(z.string().min(1))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthSignOutResponse = z.object({
    status: z.enum(['success'])
});

export const zAuthGetSessionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthGetSessionResponse = z.object({
    sessionType: z.enum(['anonymous', 'authenticated']),
    csrfToken: z.union([
        z.string(),
        z.null()
    ]),
    session: z.union([
        z.object({
            expiresAt: zInstantOutput,
            lastActivityAt: zInstantOutput,
            creationSource: z.string()
        }),
        z.null()
    ]),
    user: z.union([
        z.object({
            id: z.string()
        }),
        z.null()
    ])
});

export const zAuthSendSignInOtpData = z.object({
    body: z.object({
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        language: z.optional(z.enum(['en', 'it'])),
        rememberMe: z.optional(z.boolean())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthSendSignInOtpResponse = z.object({
    status: z.enum(['success']),
    emailOtpToken: z.string()
});

export const zAuthSignInWithEmailOtpData = z.object({
    body: z.object({
        otp: z.string().min(1),
        emailOtpToken: z.string(),
        language: z.optional(z.enum(['en', 'it']))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthSignInWithEmailOtpResponse = z.object({
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    user: zAuthIdentity,
    status: z.enum(['success'])
});

export const zAuthRequestEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthRequestEmailChangeResponse = z.object({
    status: z.enum(['success']),
    currentEmailVerificationRequired: z.boolean(),
    emailOtpToken: z.string()
});

export const zAuthConfirmEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        newOtp: z.string().min(1),
        currentOtp: z.optional(z.string().min(1)),
        emailOtpToken: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthConfirmEmailChangeResponse = z.object({
    status: z.enum(['success'])
});

export const zAuthDeleteUserData = z.object({
    body: z.object({
        token: z.optional(z.string()),
        emailOtpToken: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAuthDeleteUserResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zStatusSuccessResponse),
    z.object({
        status: z.literal('requires_otp')
    }).and(zDeleteAccountRequiresOtp)
]);

export const zBackofficeAuthSignInWithEmailData = z.object({
    body: z.object({
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        password: z.string().min(1),
        rememberMe: z.optional(z.boolean())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSignInWithEmailResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum([
        'users.manage',
        'admins.manage',
        'residences.manage',
        'call.manage',
        'event_log.read',
        'email_texts.manage',
        'sending.monitor',
        'call.monitor',
        'support.manage'
    ]))
});

export const zBackofficeAuthRequestPasswordResetData = z.object({
    body: z.object({
        type: z.enum(['magic-link']),
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthRequestPasswordResetResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthResetPasswordData = z.object({
    body: z.object({
        type: z.enum(['magic-link']),
        value: z.string().min(1),
        newPassword: zPassword,
        revokeOtherSessions: z.optional(z.boolean()).default(true)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthResetPasswordResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum([
        'users.manage',
        'admins.manage',
        'residences.manage',
        'call.manage',
        'event_log.read',
        'email_texts.manage',
        'sending.monitor',
        'call.monitor',
        'support.manage'
    ]))
});

export const zBackofficeAuthChangePasswordData = z.object({
    body: z.object({
        type: z.enum(['otp']),
        code: z.string(),
        emailOtpToken: z.string(),
        newPassword: zPassword,
        revokeOtherSessions: z.optional(z.boolean()).default(true)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthChangePasswordResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthSendChangePasswordOtpData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSendChangePasswordOtpResponse = z.object({
    status: z.enum(['success']),
    emailOtpToken: z.string()
});

export const zBackofficeAuthCreateAdminData = z.object({
    body: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            name: z.optional(z.string().min(1).max(100)),
            language: z.optional(z.enum(['en', 'it']))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthCreateAdminResponse = z.object({
    data: zBackofficeAdmin
});

export const zBackofficeAuthAcceptInviteData = z.object({
    body: z.object({
        token: z.string().min(1),
        password: zPassword,
        name: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthAcceptInviteResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum([
        'users.manage',
        'admins.manage',
        'residences.manage',
        'call.manage',
        'event_log.read',
        'email_texts.manage',
        'sending.monitor',
        'call.monitor',
        'support.manage'
    ]))
});

export const zBackofficeAuthResendInviteData = z.object({
    body: z.object({
        adminId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthResendInviteResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthListAdminsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            role: z.optional(z.nullable(z.enum(['general_admin', 'facility_manager']))),
            residenceId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            disabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            status: z.optional(z.nullable(z.enum([
                'pending',
                'active',
                'disabled'
            ])))
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthListAdminsResponse = z.object({
    data: z.array(zBackofficeAdmin),
    meta: zOffsetPaginationMeta
});

export const zBackofficeAuthExportAdminsData = z.object({
    body: z.object({
        format: z.enum(['csv', 'xlsx']),
        mode: z.optional(z.enum([
            'auto',
            'sync',
            'async'
        ])),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            role: z.optional(z.nullable(z.enum(['general_admin', 'facility_manager']))),
            residenceId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            disabled: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            status: z.optional(z.nullable(z.enum([
                'pending',
                'active',
                'disabled'
            ])))
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zBackofficeAuthExportAdminsResponse = z.union([
    z.string(),
    z.object({
        data: z.object({
            id: z.string(),
            dataset: z.string(),
            format: z.enum(['csv', 'xlsx']),
            status: z.enum(['pending']),
            rowCount: z.int().gte(0).lte(9007199254740991),
            fileName: z.string(),
            expiresAt: zInstantOutput
        })
    })
]);

export const zBackofficeAuthExportsIdData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthExportsIdResponse = z.object({
    data: z.object({
        id: z.string(),
        dataset: z.string(),
        format: z.enum(['csv', 'xlsx']),
        status: z.enum([
            'pending',
            'running',
            'completed',
            'failed',
            'expired'
        ]),
        rowCount: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ]),
        fileName: z.string(),
        mimeType: z.string(),
        errorMessage: z.union([
            z.string(),
            z.null()
        ]),
        createdAt: zInstantOutput,
        startedAt: z.union([
            z.string(),
            z.null()
        ]),
        completedAt: z.union([
            z.string(),
            z.null()
        ]),
        expiresAt: zInstantOutput,
        downloadUrl: z.union([
            z.url(),
            z.null()
        ])
    })
});

export const zBackofficeAuthDisableAdminData = z.object({
    body: z.object({
        data: z.object({
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthDisableAdminResponse = z.object({
    data: zBackofficeAdmin
});

export const zBackofficeAuthEnableAdminData = z.object({
    body: z.object({
        data: z.object({
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthEnableAdminResponse = z.object({
    data: zBackofficeAdmin
});

export const zBackofficeAuthDeleteAdminData = z.object({
    body: z.object({
        ids: z.array(z.string()).min(1).max(100)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zBackofficeAuthListSessionsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(zBackofficeListSessionsFilters)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthListSessionsResponse = z.object({
    data: z.array(zBackofficeSessionListItem),
    meta: zOffsetPaginationMeta
});

export const zBackofficeAuthRevokeSessionData = z.object({
    body: z.object({
        sessionId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthRevokeSessionResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthRequestEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthRequestEmailChangeResponse = z.object({
    status: z.enum(['success']),
    currentEmailVerificationRequired: z.boolean(),
    emailOtpToken: z.string()
});

export const zBackofficeAuthConfirmEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        newOtp: z.string().min(1),
        currentOtp: z.optional(z.string().min(1)),
        emailOtpToken: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthConfirmEmailChangeResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthGetMeData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthGetMeResponse = z.object({
    data: zBackofficeAdminProfile,
    abilities: z.array(z.enum([
        'users.manage',
        'admins.manage',
        'residences.manage',
        'call.manage',
        'event_log.read',
        'email_texts.manage',
        'sending.monitor',
        'call.monitor',
        'support.manage'
    ]))
});

export const zBackofficeAuthCreateAssetsData = z.object({
    body: z.object({
        data: z.object({
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991),
            scope: z.enum(['admin_avatar'])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthCreateAssetsResponse = z.object({
    data: zCreatedAsset
});

export const zBackofficeAuthUpdateMeData = z.object({
    body: z.object({
        data: z.object({
            name: z.optional(z.string().min(1).max(100)),
            image: z.optional(z.union([
                z.string().regex(/^ast_.*/),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthUpdateMeResponse = z.object({
    data: zBackofficeAdminProfile
});

export const zBackofficeAuthGetSessionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthGetSessionResponse = z.object({
    sessionType: z.enum(['unauthenticated', 'authenticated']),
    csrfToken: z.union([
        z.string(),
        z.null()
    ]),
    session: z.union([
        z.object({
            expiresAt: zInstantOutput,
            lastActivityAt: zInstantOutput,
            creationSource: z.enum([
                'password',
                'password_reset',
                'invite_accept'
            ])
        }),
        z.null()
    ]),
    admin: z.union([
        z.object({
            id: z.string(),
            role: z.enum(['general_admin', 'facility_manager']),
            residenceIds: z.array(z.string())
        }),
        z.null()
    ]),
    abilities: z.union([
        z.array(z.enum([
            'users.manage',
            'admins.manage',
            'residences.manage',
            'call.manage',
            'event_log.read',
            'email_texts.manage',
            'sending.monitor',
            'call.monitor',
            'support.manage'
        ])),
        z.null()
    ])
});

export const zBackofficeAuthSignOutData = z.object({
    body: z.object({
        token: z.optional(z.string().min(1))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSignOutResponse = z.object({
    status: z.enum(['success'])
});

export const zCallListManagedData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallListManagedResponse = z.object({
    data: z.array(zManagedCallSummary)
});

export const zCallGetManagedData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallGetManagedResponse = z.object({
    data: zManagedCall
});

export const zCallGetManagerHomeData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallGetManagerHomeResponse = z.object({
    data: zManagerHome
});

export const zCallSetDatesData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            startAt: zWallTime,
            endDay: zFloatingDate
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallSetDatesResponse = z.object({
    data: zManagedCall
});

export const zCallConfirmDataData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            residenceUpdatedAt: zInstant
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallConfirmDataResponse = z.object({
    data: zManagedCall
});

export const zCallOpenNextYearData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallOpenNextYearResponse = z.object({
    data: zManagedCall
});

export const zCallCorrectContractInfoData = z.object({
    body: z.object({
        data: z.object({
            contractSigningDays: z.optional(z.union([
                z.int().gte(1).lte(90),
                z.null()
            ])),
            contractSigningInstructions: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            depositInstructions: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            iban: z.optional(z.union([
                z.string().max(34),
                z.null()
            ])),
            bankAccountHolder: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallCorrectContractInfoResponse = z.object({
    data: zManagedCall
});

export const zCallPublishData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            rulesVersion: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallPublishResponse = z.object({
    data: zManagedCall
});

export const zCallDownloadDocumentData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The call notice of the residence as a PDF attachment, named `bando-{slug}.pdf`.
 */
export const zCallDownloadDocumentResponse = z.string();

export const zCallCloseIntakeData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallCloseIntakeResponse = z.object({
    data: zManagedCall
});

export const zCallStopApplicationsData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallStopApplicationsResponse = z.object({
    data: zManagedCall
});

export const zCallResumeApplicationsData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallResumeApplicationsResponse = z.object({
    data: zManagedCall
});

export const zCallMonitoringData = z.object({
    body: z.object({
        filters: z.optional(z.object({
            search: z.optional(z.string().min(1)),
            state: z.optional(z.enum([
                'published',
                'open',
                'closed'
            ])),
            academicYear: z.optional(zAcademicYear)
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallMonitoringResponse = z.object({
    data: z.array(zCallMonitoringRow),
    meta: z.object({
        academicYear: zAcademicYear,
        academicYears: z.array(zAcademicYear)
    })
});

export const zCallSendReminderData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCallSendReminderResponse = z.object({
    data: z.object({
        recipients: z.int().gte(-9007199254740991).lte(9007199254740991),
        sentAt: zInstantOutput
    })
});

export const zEmailSesEventsData = z.object({
    body: z.object({
        Type: z.string(),
        MessageId: z.string(),
        TopicArn: z.string(),
        Message: z.string(),
        Timestamp: z.string(),
        SignatureVersion: z.string(),
        Signature: z.string(),
        SigningCertURL: z.string(),
        Subject: z.optional(z.string()),
        Token: z.optional(z.string()),
        SubscribeURL: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailSesEventsResponse = z.object({
    status: z.enum(['success'])
});

export const zEmailListMessagesData = z.object({
    body: z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            state: z.optional(z.enum([
                'queued',
                'sent',
                'delivered',
                'bounced',
                'complained',
                'failed'
            ]))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailListMessagesResponse = z.object({
    data: z.array(zEmailMessage),
    meta: zCursorPaginationMeta
});

export const zEmailTextListData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailTextListResponse = z.object({
    data: z.array(zEmailText)
});

export const zEmailTextGetData = z.object({
    body: z.object({
        code: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailTextGetResponse = z.object({
    data: zEmailText
});

export const zEmailTextSaveData = z.object({
    body: z.object({
        code: z.string(),
        locale: z.enum(['en', 'it']),
        blocks: z.record(z.string(), z.string().max(5000)),
        baseVersion: z.int().gte(1).lte(9007199254740991)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailTextSaveResponse = z.object({
    data: zEmailText
});

export const zEmailTextPreviewData = z.object({
    body: z.object({
        code: z.string(),
        locale: z.enum(['en', 'it']),
        blocks: z.optional(z.record(z.string(), z.string().max(5000)))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEmailTextPreviewResponse = z.object({
    data: z.object({
        subject: z.string(),
        html: z.string()
    })
});

export const zEventLogListData = z.object({
    body: z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(zEventLogFilters)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zEventLogListResponse = z.object({
    data: z.array(zEventLogItem),
    meta: zCursorPaginationMeta
});

export const zGeoSearchMunicipalitiesData = z.object({
    body: z.object({
        query: z.string().min(2).max(100),
        limit: z.optional(z.int().gte(1).lte(20)).default(20)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zGeoSearchMunicipalitiesResponse = z.object({
    data: z.array(zMunicipality)
});

export const zGeoListInstitutionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zGeoListInstitutionsResponse = z.object({
    data: z.array(zInstitution)
});

export const zOfferPreviewLaunchData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferPreviewLaunchResponse = z.object({
    data: zOfferLaunchPreview
});

export const zOfferLaunchData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            versionNumber: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferLaunchResponse = z.object({
    data: z.object({
        launchedAt: zInstantOutput,
        offers: z.int().gte(-9007199254740991).lte(9007199254740991),
        firstSendAt: zInstantOutput
    })
});

export const zOfferListForResidenceData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            state: z.optional(z.enum([
                'scheduled',
                'sent',
                'bounced',
                'expiry_proposed',
                'accepted',
                'declined',
                'expired',
                'withdrawn',
                'revoked',
                'renounced_after_acceptance'
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferListForResidenceResponse = z.object({
    data: zOfferList,
    meta: zOffsetPaginationMeta
});

export const zOfferListMineData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferListMineResponse = z.object({
    data: z.array(zMyOffer)
});

export const zOfferGetMineData = z.object({
    body: z.object({
        data: z.object({
            offerId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferGetMineResponse = z.object({
    data: zMyOfferDetail
});

export const zOfferAcceptData = z.object({
    body: z.object({
        data: z.object({
            offerId: z.string(),
            confirmIrrevocable: z.literal(true)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferAcceptResponse = z.object({
    data: zMyOfferDetail
});

export const zOfferDeclineData = z.object({
    body: z.object({
        data: z.object({
            offerId: z.string(),
            confirmIrrevocable: z.literal(true)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferDeclineResponse = z.object({
    data: zMyOfferDetail
});

export const zOfferListExpiriesData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferListExpiriesResponse = z.object({
    data: z.array(zOfferExpiryRow)
});

export const zOfferConfirmExpiryData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferConfirmExpiryResponse = z.object({
    status: z.enum(['success'])
});

export const zOfferCreateReplyProofUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferCreateReplyProofUploadResponse = z.object({
    data: zCreatedAsset
});

export const zOfferReadReplyProofData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            assetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferReadReplyProofResponse = z.object({
    data: z.object({
        receivedAt: z.union([
            z.string(),
            z.null()
        ]),
        senderAddress: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zOfferRecordReplyData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            decision: z.enum(['accept', 'decline']),
            receivedAt: zInstant,
            proofAssetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferRecordReplyResponse = z.object({
    status: z.enum(['success'])
});

export const zOfferResendData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferResendResponse = z.object({
    data: z.object({
        sendAfter: zInstantOutput
    })
});

export const zOfferRecordContactNoteData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            note: z.string().min(3).max(500)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferRecordContactNoteResponse = z.object({
    status: z.enum(['success'])
});

export const zOfferGetPecTextData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            sentAt: z.optional(zInstant)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferGetPecTextResponse = z.object({
    data: zOfferPecText
});

export const zOfferRecordPecSendData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            sentAt: zInstant
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zOfferRecordPecSendResponse = z.object({
    status: z.enum(['success'])
});

export const zPublicRankingGetData = z.object({
    body: z.object({
        residence: z.string().min(1).max(128),
        date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        version: z.optional(z.int().gt(0).lte(9007199254740991))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPublicRankingGetResponse = z.object({
    data: zPublicRanking
});

export const zPublicResidenceListData = z.object({
    body: z.object({
        filters: z.optional(z.object({
            city: z.optional(z.string().min(1).max(120)),
            roomType: z.optional(z.enum(['single', 'double'])),
            service: z.optional(z.enum([
                'study_room',
                'library',
                'common_kitchen',
                'common_room',
                'laundry',
                'garden',
                'wifi',
                'air_conditioning',
                'bed_linen',
                'cleaning',
                'private_bathroom',
                'canteen',
                'vending',
                'security',
                'gym',
                'sports_field',
                'bike_parking',
                'parking',
                'shuttle',
                'elevator'
            ])),
            equipped: z.optional(z.boolean()),
            sort: z.optional(z.enum(['name', 'remaining_seats']))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPublicResidenceListResponse = z.object({
    data: zPublicResidenceList
});

export const zPublicResidenceGetData = z.object({
    body: z.object({
        slug: z.string().min(1).max(128),
        preview: z.optional(z.string().min(1).max(2048))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPublicResidenceGetResponse = z.object({
    data: zPublicResidence
});

export const zPublicResidenceDownloadCallDocumentData = z.object({
    body: z.object({
        slug: z.string().min(1).max(128)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The call notice of the residence as a PDF attachment, named `bando-{slug}.pdf`.
 */
export const zPublicResidenceDownloadCallDocumentResponse = z.string();

export const zPublicResidenceGetApplicationRulesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPublicResidenceGetApplicationRulesResponse = z.object({
    data: zPublicApplicationRules
});

export const zRankingGetControlData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            list: z.optional(z.enum([
                'freshers',
                'later_years',
                'doctoral',
                'q70',
                'q70_dsu_seat',
                'not_admitted',
                'excluded'
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingGetControlResponse = z.object({
    data: zRankingControl,
    meta: zOffsetPaginationMeta
});

export const zRankingGetRecalculationData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingGetRecalculationResponse = z.object({
    data: z.object({
        pendingSince: z.union([
            z.string(),
            z.null()
        ]),
        failing: z.boolean()
    })
});

export const zRankingExportData = z.object({
    body: z.object({
        format: z.enum(['csv', 'xlsx']),
        mode: z.optional(z.enum([
            'auto',
            'sync',
            'async'
        ])),
        filters: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zRankingExportResponse = z.union([
    z.string(),
    z.object({
        data: z.object({
            id: z.string(),
            dataset: z.string(),
            format: z.enum(['csv', 'xlsx']),
            status: z.enum(['pending']),
            rowCount: z.int().gte(0).lte(9007199254740991),
            fileName: z.string(),
            expiresAt: zInstantOutput
        })
    })
]);

export const zRankingApproveData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            versionNumber: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingApproveResponse = z.object({
    data: z.object({
        state: z.enum([
            'control',
            'published_review',
            'final'
        ]),
        pageState: z.enum([
            'placeholder',
            'enabled',
            'disabled'
        ]),
        approvedAt: z.union([
            z.string(),
            z.null()
        ]),
        publishedAt: z.union([
            z.string(),
            z.null()
        ]),
        reviewWindowEndsAt: z.union([
            z.string(),
            z.null()
        ]),
        versionNumber: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zRankingDisablePageData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            reason: z.string().min(10).max(500)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingDisablePageResponse = z.object({
    data: z.object({
        pageState: z.enum([
            'placeholder',
            'enabled',
            'disabled'
        ]),
        disabledAt: zInstantOutput
    })
});

export const zRankingGetForStudentData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingGetForStudentResponse = z.object({
    data: zStudentRanking
});

export const zRankingGetProvisionalData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            list: z.optional(z.enum([
                'freshers',
                'later_years',
                'doctoral',
                'q70',
                'q70_dsu_seat',
                'not_admitted',
                'excluded'
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingGetProvisionalResponse = z.object({
    data: zRankingProvisional,
    meta: zOffsetPaginationMeta
});

export const zRankingCreateReportData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string(),
            type: z.enum([
                'my_data_wrong',
                'my_position_wrong',
                'other'
            ]),
            description: z.string().min(10).max(2000),
            assetId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingCreateReportResponse = z.object({
    data: zStudentRankingReport
});

export const zRankingCreateReportUploadData = z.object({
    body: z.object({
        data: z.object({
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingCreateReportUploadResponse = z.object({
    data: zCreatedAsset
});

export const zRankingListMyReportsData = z.object({
    body: z.object({
        data: z.object({
            submissionId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingListMyReportsResponse = z.object({
    data: z.array(zStudentRankingReport)
});

export const zRankingCloseReportData = z.object({
    body: z.object({
        data: z.object({
            reportId: z.string(),
            resolution: z.enum(['no_change', 'corrected']),
            response: z.string().min(10).max(2000),
            fact: z.optional(z.object({
                type: z.enum(['requirement_flag', 'application_submission_correction']),
                id: z.string()
            })),
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingCloseReportResponse = z.object({
    data: z.object({
        closed: z.literal(true)
    })
});

export const zRankingDownloadReportFileData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            reportId: z.string(),
            view: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingDownloadReportFileResponse = z.object({
    data: z.object({
        url: z.string(),
        inline: z.boolean(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991),
        subjectId: z.string()
    })
});

export const zRankingGetReportData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            reportId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingGetReportResponse = z.object({
    data: zManagerRankingReport
});

export const zRankingListReportsData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            state: z.optional(z.enum(['open', 'closed']))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingListReportsResponse = z.object({
    data: z.array(zManagerRankingReportSummary)
});

export const zRankingRevokeDisabilityPriorityData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string(),
            note: z.optional(z.union([
                z.string().max(1000),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingRevokeDisabilityPriorityResponse = z.object({
    status: z.enum(['success'])
});

export const zRankingRestoreDisabilityPriorityData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            submissionId: z.string(),
            reason: z.string().min(1).max(1000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRankingRestoreDisabilityPriorityResponse = z.object({
    status: z.enum(['success'])
});

export const zRequirementFlagListForResidenceData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            state: z.optional(z.enum([
                'open',
                'awaiting_clarification',
                'clarification_received',
                'clarification_expired',
                'resolved_confirmed',
                'resolved_corrected'
            ])),
            code: z.optional(z.enum([
                'iseeu_above',
                'ispeu_above',
                'cfu_below_min',
                'offsite_not_met'
            ])),
            quota: z.optional(z.enum(['q30', 'q70'])),
            open: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRequirementFlagListForResidenceResponse = z.object({
    data: z.array(zRequirementFlagListRow),
    meta: zOffsetPaginationMeta,
    counters: zRequirementFlagCounters
});

export const zRequirementFlagGetForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            flagId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRequirementFlagGetForResidenceResponse = z.object({
    data: zRequirementFlagDetail
});

export const zRequirementFlagStartReviewData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            flagId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRequirementFlagStartReviewResponse = z.object({
    data: z.object({
        reviewingSince: zInstantOutput
    })
});

export const zRequirementFlagResolveData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            flagId: z.string(),
            decision: z.union([
                z.object({
                    outcome: z.enum(['confirmed']),
                    causeCode: z.enum([
                        'iseeu_documented_above',
                        'ispeu_documented_above',
                        'cfu_documented_below',
                        'offsite_not_met_documented',
                        'not_proven_after_clarification',
                        'declared_value_differs',
                        'document_missing',
                        'document_unreadable',
                        'document_inconsistent'
                    ]),
                    evidence: z.union([
                        z.object({
                            kind: z.enum(['file']),
                            fileId: z.string(),
                            page: z.int().gt(0).lte(9007199254740991)
                        }),
                        z.object({
                            kind: z.enum(['clarification_expired'])
                        })
                    ])
                }),
                z.object({
                    outcome: z.enum(['corrected']),
                    causeCode: z.enum([
                        'iseeu_documented_above',
                        'ispeu_documented_above',
                        'cfu_documented_below',
                        'offsite_not_met_documented',
                        'not_proven_after_clarification',
                        'declared_value_differs',
                        'document_missing',
                        'document_unreadable',
                        'document_inconsistent'
                    ]),
                    correctedValue: z.union([
                        z.int().gte(0).lte(9007199254740991),
                        z.enum([
                            'off_site',
                            'commuter',
                            'in_site'
                        ])
                    ]),
                    evidence: z.union([
                        z.object({
                            kind: z.enum(['file']),
                            fileId: z.string(),
                            page: z.int().gt(0).lte(9007199254740991)
                        }),
                        z.object({
                            kind: z.enum(['clarification_expired'])
                        })
                    ])
                }),
                z.object({
                    outcome: z.enum(['clarification']),
                    causeCode: z.enum([
                        'iseeu_documented_above',
                        'ispeu_documented_above',
                        'cfu_documented_below',
                        'offsite_not_met_documented',
                        'not_proven_after_clarification',
                        'declared_value_differs',
                        'document_missing',
                        'document_unreadable',
                        'document_inconsistent'
                    ]),
                    question: z.string().min(10).max(2000)
                })
            ])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRequirementFlagResolveResponse = z.object({
    data: z.object({
        id: z.string(),
        state: z.enum([
            'open',
            'awaiting_clarification',
            'clarification_received',
            'clarification_expired',
            'resolved_confirmed',
            'resolved_corrected'
        ]),
        clarificationDueAt: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zRequirementFlagDownloadClarificationFileData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            flagId: z.string(),
            view: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRequirementFlagDownloadClarificationFileResponse = z.object({
    data: z.object({
        url: z.string(),
        inline: z.boolean(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991),
        subjectId: z.string()
    })
});

export const zResidenceCreateData = z.object({
    body: z.object({
        data: zResidenceCreate
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceCreateResponse = z.object({
    data: zResidence,
    outcome: z.enum(['invited', 'linked']),
    inviteSent: z.boolean()
});

export const zResidenceUpdateData = z.object({
    body: z.object({
        data: z.object({
            name: z.optional(z.string().min(1).max(200)),
            operatorLegalName: z.optional(z.union([
                z.string().min(1).max(300),
                z.null()
            ])),
            grantDecree: z.optional(z.union([
                z.string().min(1).max(300),
                z.null()
            ])),
            dpoContact: z.optional(z.union([
                z.string().min(1).max(300),
                z.null()
            ])),
            infoEmail: z.optional(z.union([
                z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
                z.null()
            ])),
            sites: z.optional(z.array(zResidenceSiteData).max(3)),
            pecAddress: z.optional(z.union([
                z.email().max(256).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
                z.null()
            ])),
            q30SingleBeds: z.optional(z.int().gte(0).lte(10000)),
            q30DoubleBeds: z.optional(z.int().gte(0).lte(10000)),
            q70SingleBeds: z.optional(z.int().gte(0).lte(10000)),
            q70DoubleBeds: z.optional(z.int().gte(0).lte(10000)),
            fundedBeds: z.optional(z.union([
                z.int().gte(0).lte(10000),
                z.null()
            ])),
            q70SingleRateCents: z.optional(z.union([
                z.int().gte(0).lte(1000000),
                z.null()
            ])),
            q70DoubleRateCents: z.optional(z.union([
                z.int().gte(0).lte(1000000),
                z.null()
            ])),
            services: z.optional(z.array(z.enum([
                'study_room',
                'library',
                'common_kitchen',
                'common_room',
                'laundry',
                'garden',
                'wifi',
                'air_conditioning',
                'bed_linen',
                'cleaning',
                'private_bathroom',
                'canteen',
                'vending',
                'security',
                'gym',
                'sports_field',
                'bike_parking',
                'parking',
                'shuttle',
                'elevator'
            ])).max(20)),
            admittedInstitutions: z.optional(z.array(z.string().min(1).max(10)).max(50)),
            callLinkUrl: z.optional(z.union([
                z.url(),
                z.null()
            ])),
            contractSigningDays: z.optional(z.union([
                z.int().gte(1).lte(90),
                z.null()
            ])),
            contractSigningInstructions: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            depositInstructions: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            iban: z.optional(z.union([
                z.string().max(34),
                z.null()
            ])),
            bankAccountHolder: z.optional(z.union([
                z.string().min(1).max(2000),
                z.null()
            ])),
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceUpdateResponse = z.object({
    data: zResidence
});

export const zResidenceUpdateLocationData = z.object({
    body: z.object({
        data: z.object({
            id: z.string(),
            siteId: z.string(),
            location: z.union([
                z.object({
                    latitude: z.number().gte(35).lte(48),
                    longitude: z.number().gte(6).lte(19),
                    googlePlaceId: z.union([
                        z.string().min(1).max(256),
                        z.null()
                    ])
                }),
                z.null()
            ])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceUpdateLocationResponse = z.object({
    data: zResidence
});

export const zResidenceCorrectFundedBedsData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            fundedBeds: z.int().gte(0).lte(10000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceCorrectFundedBedsResponse = z.object({
    data: zManagedCall
});

export const zResidenceListData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            search: z.optional(z.string().min(1))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceListResponse = z.object({
    data: z.array(zResidence),
    meta: zOffsetPaginationMeta
});

export const zResidenceGetData = z.object({
    body: z.object({
        filters: z.object({
            ids: z.array(z.string()).min(1).max(100)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceGetResponse = z.object({
    data: z.array(zResidence)
});

export const zResidenceGetManagedData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceGetManagedResponse = z.object({
    data: zResidence
});

export const zResidenceCreateManagerData = z.object({
    body: z.object({
        data: zResidenceManagerData
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceCreateManagerResponse = z.object({
    data: zResidenceManager,
    outcome: z.enum(['invited', 'linked'])
});

export const zResidenceListManagersData = z.object({
    body: z.object({
        filters: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceListManagersResponse = z.object({
    data: z.array(zResidenceManager)
});

export const zResidenceRemoveManagerData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            managerId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceRemoveManagerResponse = z.object({
    data: zResidenceManager
});

export const zResidenceCreatePhotoUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceCreatePhotoUploadResponse = z.object({
    data: zCreatedAsset
});

export const zResidenceAddPhotosData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            assetIds: z.array(z.string().regex(/^ast_.*/)).min(1).max(10)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceAddPhotosResponse = z.object({
    data: zResidence
});

export const zResidenceReorderPhotosData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            photoIds: z.array(z.string()).min(1).max(10)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceReorderPhotosResponse = z.object({
    data: zResidence
});

export const zResidenceRemovePhotoData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceRemovePhotoResponse = z.object({
    data: zResidence
});

export const zResidenceCreatePreviewLinkData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceCreatePreviewLinkResponse = z.object({
    data: z.object({
        url: z.string(),
        expiresAt: zInstantOutput
    })
});

export const zResidenceSendMailboxTestData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceSendMailboxTestResponse = z.object({
    data: zMailboxTestStatus
});

export const zResidenceGetMailboxTestStatusData = z.object({
    body: z.object({
        filters: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceGetMailboxTestStatusResponse = z.object({
    data: z.union([
        z.object({
            id: z.string(),
            residenceId: z.string(),
            address: z.string(),
            delivery: z.enum([
                'sending',
                'delivered',
                'refused'
            ]),
            sentAt: zInstantOutput,
            confirmedAt: z.union([
                z.string(),
                z.null()
            ]),
            confirmedByName: z.union([
                z.string(),
                z.null()
            ]),
            attemptsLeft: z.int().gte(0).lte(9007199254740991)
        }),
        z.null()
    ])
});

export const zResidenceConfirmMailboxTestCodeData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            code: z.string().regex(/^\d{6}$/)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceConfirmMailboxTestCodeResponse = z.object({
    data: zMailboxTestStatus
});

export const zResidenceGetDsuRateData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceGetDsuRateResponse = z.object({
    data: z.union([
        z.object({
            singleRateCents: z.int().gte(-9007199254740991).lte(9007199254740991),
            doubleRateCents: z.int().gte(-9007199254740991).lte(9007199254740991),
            setAt: zInstantOutput
        }),
        z.null()
    ])
});

export const zResidenceSetDsuRateData = z.object({
    body: z.object({
        data: z.object({
            singleRateCents: z.int().gte(5000).lte(1000000),
            doubleRateCents: z.int().gte(5000).lte(1000000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zResidenceSetDsuRateResponse = z.object({
    data: zDsuRate
});

export const zSendingAnomalyListResidencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyListResidencesResponse = z.object({
    data: z.array(zResidenceSending),
    withoutResidence: z.object({
        transmission_not_delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
        email_bounced: z.int().gte(-9007199254740991).lte(9007199254740991),
        ranking_failed: z.int().gte(-9007199254740991).lte(9007199254740991),
        offer_not_sent: z.int().gte(-9007199254740991).lte(9007199254740991),
        offer_bounced: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zSendingAnomalyListData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            kind: z.optional(z.enum([
                'transmission_not_delivered',
                'email_bounced',
                'ranking_failed',
                'offer_not_sent',
                'offer_bounced'
            ])),
            residenceId: z.optional(z.string()),
            state: z.optional(z.enum(['open', 'closed']))
        })).default({})
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyListResponse = z.object({
    data: z.array(zSendingAnomalyItem),
    meta: zOffsetPaginationMeta
});

export const zSendingAnomalyGetData = z.object({
    body: z.object({
        data: z.object({
            anomalyId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyGetResponse = z.object({
    data: zSendingAnomalyDetail
});

export const zSendingAnomalyGetRecipientData = z.object({
    body: z.object({
        data: z.object({
            anomalyId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyGetRecipientResponse = z.object({
    data: zSendingAnomalyRecipient
});

export const zSendingAnomalyNotifyManagerData = z.object({
    body: z.object({
        data: z.object({
            anomalyId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyNotifyManagerResponse = z.object({
    data: z.object({
        managersNotified: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zSendingAnomalyCloseData = z.object({
    body: z.object({
        data: z.object({
            anomalyId: z.string(),
            note: z.string().min(1).max(1000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSendingAnomalyCloseResponse = z.object({
    data: z.object({
        closed: z.literal(true)
    })
});

export const zStudentGetProfileData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentGetProfileResponse = z.object({
    data: zStudentProfileView
});

export const zStudentUpdateProfileData = z.object({
    body: z.object({
        data: zStudentProfileUpdate
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentUpdateProfileResponse = z.object({
    data: zStudentProfileView
});

export const zStudentReleaseTaxCodeData = z.object({
    body: z.object({
        data: z.object({
            taxCode: z.string().min(1).max(32),
            reason: z.optional(z.string().max(500))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentReleaseTaxCodeResponse = z.object({
    data: z.object({
        userId: z.string()
    })
});

export const zStudentFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentFavoriteListResponse = z.object({
    data: zFavoriteList
});

export const zStudentFavoriteAddData = z.object({
    body: z.object({
        slug: z.string().min(1).max(128)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentFavoriteAddResponse = z.object({
    data: zFavoriteList
});

export const zStudentFavoriteRemoveData = z.object({
    body: z.object({
        slug: z.string().min(1).max(128)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentFavoriteRemoveResponse = z.object({
    data: zFavoriteList
});

export const zStudentFavoriteMergeData = z.object({
    body: z.object({
        slugs: z.array(z.string().min(1).max(128)).max(100)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zStudentFavoriteMergeResponse = z.object({
    data: zFavoriteList
});

export const zSupportSearchStudentsData = z.object({
    body: z.object({
        query: z.string().min(1).max(256)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportSearchStudentsResponse = z.object({
    kind: z.enum([
        'protocol',
        'tax_code',
        'email'
    ]),
    tooMany: z.boolean(),
    data: z.array(zSupportStudentItem)
});

export const zSupportGetStudentData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportGetStudentResponse = z.object({
    data: zSupportStudent
});

export const zSupportResendAccessCodeData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportResendAccessCodeResponse = z.object({
    data: z.object({
        sent: z.literal(true)
    })
});

export const zSupportResendReceiptData = z.object({
    body: z.object({
        data: z.object({
            applicationId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportResendReceiptResponse = z.object({
    data: z.object({
        sent: z.literal(true)
    })
});

export const zSupportOpenRequestData = z.object({
    body: z.object({
        data: z.object({
            userId: z.string(),
            summary: z.string().min(1).max(2000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportOpenRequestResponse = z.object({
    data: z.object({
        requestId: z.string()
    })
});

export const zSupportCloseRequestData = z.object({
    body: z.object({
        data: z.object({
            requestId: z.string(),
            answer: z.string().min(1).max(2000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportCloseRequestResponse = z.object({
    data: z.object({
        closed: z.literal(true)
    })
});

export const zSupportListOpenRequestsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zSupportListOpenRequestsResponse = z.object({
    data: z.array(zSupportOpenRequestItem),
    meta: zOffsetPaginationMeta
});

export const zUsersGetMeData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zUsersGetMeResponse = z.object({
    data: zUser
});

export const zVerificationListForResidenceData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.object({
            state: z.optional(z.enum([
                'pending',
                'compliant',
                'excluded'
            ])),
            search: z.optional(z.string().min(1).max(100)),
            residenceId: z.string(),
            callId: z.optional(z.string())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationListForResidenceResponse = z.object({
    data: z.array(zVerificationListRow),
    meta: zOffsetPaginationMeta,
    counters: zVerificationCounters
});

export const zVerificationGetForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            verificationId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationGetForResidenceResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationGetNeighborsForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            verificationId: z.string()
        }),
        filters: z.optional(z.object({
            state: z.optional(z.enum([
                'pending',
                'compliant',
                'excluded'
            ])),
            search: z.optional(z.string().min(1).max(100))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationGetNeighborsForResidenceResponse = z.object({
    data: zVerificationNeighbors
});

export const zVerificationCheckItemData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            item: z.enum([
                'identity',
                'signed_annex',
                'enrollment',
                'economic',
                'credits'
            ]),
            matches: z.boolean()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationCheckItemResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationCheckDocumentedValueData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            item: z.enum(['economic', 'credits']),
            documented: zVerificationDocumentedValues
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationCheckDocumentedValueResponse = z.object({
    data: zVerificationDocumentedValueEffect
});

export const zVerificationRecordDifferenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            item: z.enum(['economic', 'credits']),
            documented: zVerificationDocumentedValues,
            note: z.optional(z.union([
                z.string().max(1000),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationRecordDifferenceResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationMarkCompliantData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationMarkCompliantResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationRequestStudentNumberData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationRequestStudentNumberResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationReadStudentNumberProofData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            assetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationReadStudentNumberProofResponse = z.object({
    data: z.object({
        receivedAt: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zVerificationRecordStudentNumberData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            studentNumber: z.string().min(1).max(64),
            receivedAt: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            proofAssetId: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationRecordStudentNumberResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationCreateProofUploadData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            fileName: z.string().min(1).max(255),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationCreateProofUploadResponse = z.object({
    data: zCreatedAsset
});

export const zVerificationExcludeData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            item: z.enum([
                'identity',
                'signed_annex',
                'enrollment',
                'economic',
                'credits'
            ]),
            causeCode: z.enum([
                'identity_document_invalid',
                'duplicate_application',
                'annex_not_valid',
                'enrollment_missing',
                'iseeu_documented_differs',
                'ispeu_documented_differs',
                'cfu_documented_differs'
            ]),
            documentedValue: z.optional(z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ])),
            proofAssetId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            note: z.optional(z.union([
                z.string().max(1000),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationExcludeResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationCorrectExclusionData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            causeCode: z.enum(['material_verification_error']),
            proofAssetId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            note: z.optional(z.union([
                z.string().max(1000),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationCorrectExclusionResponse = z.object({
    data: zVerificationDetail
});

export const zVerificationDownloadExclusionProofData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            verificationId: z.string(),
            exclusionId: z.string(),
            proof: z.enum(['exclusion', 'correction']),
            view: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zVerificationDownloadExclusionProofResponse = z.object({
    data: z.object({
        url: z.string(),
        inline: z.boolean(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zRoomOverviewForResidenceData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            state: z.optional(z.enum([
                'to_propose',
                'room_proposed',
                'checked_in',
                'forfeited'
            ])),
            verificationState: z.optional(z.enum([
                'pending',
                'compliant',
                'excluded'
            ])),
            search: z.optional(z.string().min(1).max(100))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRoomOverviewForResidenceResponse = z.object({
    data: z.array(zRoomOverviewRow),
    meta: zOffsetPaginationMeta,
    causes: z.array(zAfterAcceptanceCause),
    quotas: z.array(zRoomQuotaCount),
    sites: z.array(zRoomSiteCount)
});

export const zRoomProposeData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            sitePosition: z.int().gte(1).lte(3),
            roomType: z.enum(['single', 'double']),
            equipped: z.boolean()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRoomProposeResponse = z.object({
    status: z.enum(['success'])
});

export const zRoomConfirmCheckInData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            checkInDate: zFloatingDate
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRoomConfirmCheckInResponse = z.object({
    status: z.enum(['success'])
});

export const zRoomRecordAfterAcceptanceFactData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            offerId: z.string(),
            causeCode: z.enum(['contract_not_signed', 'written_renunciation']),
            factDate: zFloatingDate,
            proofAssetId: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            note: z.optional(z.union([
                z.string().max(1000),
                z.null()
            ]))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zRoomRecordAfterAcceptanceFactResponse = z.object({
    status: z.enum(['success'])
});

export const zDsuQuotaGetForResidenceData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDsuQuotaGetForResidenceResponse = z.object({
    data: z.object({
        launched: z.boolean(),
        ministryAnswer: zDsuMinistryAnswerView,
        current: zDsuQuotaValues,
        seats: zDsuQuotaSeats,
        history: z.array(zDsuQuotaHistoryRow)
    })
});

export const zDsuQuotaExportReportData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The report of the DSU quota as a PDF attachment, named `quota-dsu-{yyyyMMdd-HHmm}.pdf`.
 */
export const zDsuQuotaExportReportResponse = z.string();

export const zDsuQuotaRecordMinistryAnswerData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            answer: z.enum(['granted', 'denied']),
            answeredOn: zFloatingDate,
            documentAssetId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDsuQuotaRecordMinistryAnswerResponse = z.object({
    data: zDsuMinistryAnswerView
});

export const zDsuQuotaUnlockOffersData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            reason: z.string().min(10).max(2000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDsuQuotaUnlockOffersResponse = z.object({
    data: zDsuMinistryAnswerView
});

export const zDsuQuotaDownloadMinistryAnswerData = z.object({
    body: z.object({
        data: z.object({
            residenceId: z.string(),
            callId: z.optional(z.string()),
            view: z.optional(z.boolean())
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDsuQuotaDownloadMinistryAnswerResponse = z.object({
    data: z.object({
        url: z.string(),
        inline: z.boolean(),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckResponse = z.enum(['Healthy']);

export const zHealthCheckServicesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zHealthCheckBackgroundData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckBackgroundResponse = z.object({
    status: z.enum([
        'ok',
        'stale',
        'disabled'
    ]),
    worker: z.object({
        status: z.enum([
            'ok',
            'stale',
            'disabled'
        ]),
        lastBeatAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    cron: z.object({
        status: z.enum([
            'ok',
            'stale',
            'disabled'
        ]),
        lastBeatAt: z.union([
            z.string(),
            z.null()
        ])
    })
});
